
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/**
 * Pac-Man by Oscar Wallhult
 */ /**
 * Pac-Man by Oscar Wallhult
 */ var $28edd11f6c7e9f5f$exports = {};
'use strict';
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
$28edd11f6c7e9f5f$exports = $28edd11f6c7e9f5f$var$EventEmitter;


class $5a653ab238c8deb0$export$4293555f241ae35a {
    constructor(){
        this.eventEmitter = new (0, (/*@__PURE__*/$parcel$interopDefault($28edd11f6c7e9f5f$exports)))();
    }
    emit(evt, data) {
        this.eventEmitter.emit(evt, data);
        return this;
    }
    on(evt, handler) {
        this.eventEmitter.on(evt, handler);
        return this;
    }
    off(evt, handler) {
        this.eventEmitter.off(evt, handler);
        return this;
    }
    unsubscribeAll(evt) {
        this.eventEmitter.removeAllListeners(evt);
        return this;
    }
}


const $1db270861bd59532$var$defaultOptions = {
    axis_threshold: .5
};
class $1db270861bd59532$var$Gamerpad extends (0, $5a653ab238c8deb0$export$4293555f241ae35a) {
    constructor(options = $1db270861bd59532$var$defaultOptions){
        super();
        this.polling = false;
        this.gamepads = {};
        this.onGamePadConnected = (e)=>{
            const { gamepad: gamepad } = e;
            if (!gamepad) return;
            this.gamepads[gamepad.index] = gamepad;
            this.emit('connected', {
                gamepad: gamepad
            });
        };
        this.onGamePadDisconnected = (e)=>{
            const { gamepad: gamepad } = e;
            if (!gamepad) return;
            delete this.gamepads[gamepad.index];
            this.emit('disconnected', {
                gamepad: gamepad
            });
        };
        this.poll = ()=>{
            const gamepads = navigator.getGamepads();
            if (gamepads) Array.from(gamepads).forEach((gamepad)=>{
                if (gamepad) {
                    gamepad.axes.forEach((value, axis)=>{
                        const oldValue = this.gamepads[gamepad.index].axes[axis];
                        if (value !== oldValue && Math.abs(value) > this.options.axis_threshold) this.emit('axis_changed', {
                            gamepad: gamepad,
                            axis: axis,
                            value: value
                        });
                    });
                    gamepad.buttons.forEach((value, button)=>{
                        const oldValue = this.gamepads[gamepad.index].buttons[button];
                        if (value.pressed !== oldValue.pressed || value.touched !== oldValue.touched || value.value !== oldValue.value) this.emit('button_changed', {
                            gamepad: gamepad,
                            button: button,
                            ...value
                        });
                    });
                    this.gamepads[gamepad.index] = gamepad;
                }
            });
            if (this.polling) window.requestAnimationFrame(()=>this.poll());
        };
        this.options = options;
        if (!navigator.getGamepads) return;
        window.addEventListener('gamepadconnected', this.onGamePadConnected);
        window.addEventListener('gamepaddisconnected', this.onGamePadDisconnected);
        this.startPolling();
    }
    destroy() {
        window.removeEventListener('gamepadconnected', this.onGamePadConnected);
        window.removeEventListener('gamepaddisconnected', this.onGamePadDisconnected);
    }
    startPolling() {
        this.polling = true;
        this.poll();
    }
    stopPolling() {
        this.polling = false;
    }
}
var $1db270861bd59532$export$2e2bcd8739ae039 = new $1db270861bd59532$var$Gamerpad();


var $3b35f402ec1d6958$export$eb5ccdbd077479c = /*#__PURE__*/ function(GameState) {
    GameState[GameState["Ready"] = 0] = "Ready";
    GameState[GameState["Playing"] = 1] = "Playing";
    GameState[GameState["Paused"] = 2] = "Paused";
    GameState[GameState["GameOver"] = 3] = "GameOver";
    return GameState;
}({});
var $3b35f402ec1d6958$export$cd0f44441c3b7719 = /*#__PURE__*/ function(Key) {
    Key[Key["Up"] = 38] = "Up";
    Key[Key["Down"] = 40] = "Down";
    Key[Key["Left"] = 37] = "Left";
    Key[Key["Right"] = 39] = "Right";
    Key[Key["Space"] = 32] = "Space";
    Key[Key["P"] = 80] = "P";
    Key[Key["W"] = 87] = "W";
    Key[Key["S"] = 83] = "S";
    Key[Key["A"] = 65] = "A";
    Key[Key["D"] = 68] = "D";
    return Key;
}({});
var $3b35f402ec1d6958$export$cacd6541cfeeb6c1 = /*#__PURE__*/ function(Direction) {
    Direction[Direction["Left"] = 0] = "Left";
    Direction[Direction["Right"] = 1] = "Right";
    Direction[Direction["Up"] = 2] = "Up";
    Direction[Direction["Down"] = 3] = "Down";
    return Direction;
}({});


const $75448a1de67727b4$var$loadSprite = (name)=>{
    return new Promise((resolve, reject)=>{
        const sprite = new Image();
        sprite.onload = ()=>resolve({
                name: name,
                sprite: sprite
            });
        sprite.onerror = (err)=>{
            console.log({
                err: err
            });
            reject(err);
        };
        sprite.src = `./assets/${name}.png`;
    });
};
const $75448a1de67727b4$export$cd054587bb4ae1d2 = (sources)=>{
    const sprites = sources.map($75448a1de67727b4$var$loadSprite);
    return Promise.all(sprites);
};


class $59ac15d34719d398$export$2e2bcd8739ae039 {
    constructor(_x, _y){
        this._x = _x;
        this._y = _y;
    }
    get x() {
        return this._x;
    }
    get y() {
        return this._y;
    }
    static isSame(a, b) {
        return a.x === b.x && a.y === b.y;
    }
    toJSON() {
        return {
            x: this.x,
            y: this.y
        };
    }
}


const $565bb8264fce4bd8$var$limit = (list, size)=>list.slice(0, size);
const $565bb8264fce4bd8$var$sortByScore = (list)=>list.sort((a, b)=>a.score > b.score ? -1 : 1);
const $565bb8264fce4bd8$var$hiScores = [
    {
        name: "oscar",
        score: 100,
        timestamp: 1
    },
    {
        name: "oscar",
        score: 100,
        timestamp: 1
    },
    {
        name: "oscar",
        score: 400,
        timestamp: 1
    },
    {
        name: "oscar",
        score: 200,
        timestamp: 1
    },
    {
        name: "oscar",
        score: 500,
        timestamp: 1
    },
    {
        name: "oscar",
        score: 1000,
        timestamp: 1
    }
];
const $565bb8264fce4bd8$var$STORAGE_KEY = 'pacman-highscore';
const $565bb8264fce4bd8$export$2fcfd70a284e8a97 = (name, score)=>({
        name: name,
        score: score,
        timestamp: Date.now()
    });
const $565bb8264fce4bd8$export$3de7d70fb5123830 = ()=>{
    const scores = localStorage.getItem($565bb8264fce4bd8$var$STORAGE_KEY);
    if (!scores) {
        $565bb8264fce4bd8$export$61c0464fd40edb58($565bb8264fce4bd8$var$hiScores);
        return $565bb8264fce4bd8$var$hiScores;
    }
    return scores ? JSON.parse(scores) : [];
};
const $565bb8264fce4bd8$export$61c0464fd40edb58 = (scores)=>localStorage.setItem($565bb8264fce4bd8$var$STORAGE_KEY, JSON.stringify(scores));
const $565bb8264fce4bd8$export$99f9e493cb5d4ab9 = (scores = $565bb8264fce4bd8$export$3de7d70fb5123830())=>$565bb8264fce4bd8$var$limit($565bb8264fce4bd8$var$sortByScore(scores), 5);


var $037a65334863e5a8$exports = {};
$037a65334863e5a8$exports = JSON.parse("{\"0\":{\"x\":0,\"y\":1},\"1\":{\"x\":1,\"y\":1},\"2\":{\"x\":2,\"y\":1},\"3\":{\"x\":3,\"y\":1},\"4\":{\"x\":4,\"y\":1},\"5\":{\"x\":5,\"y\":1},\"6\":{\"x\":6,\"y\":1},\"7\":{\"x\":7,\"y\":1},\"8\":{\"x\":8,\"y\":1},\"9\":{\"x\":9,\"y\":1},\"A\":{\"x\":0,\"y\":0},\"B\":{\"x\":1,\"y\":0},\"C\":{\"x\":2,\"y\":0},\"D\":{\"x\":3,\"y\":0},\"E\":{\"x\":4,\"y\":0},\"F\":{\"x\":5,\"y\":0},\"G\":{\"x\":6,\"y\":0},\"H\":{\"x\":7,\"y\":0},\"I\":{\"x\":8,\"y\":0},\"J\":{\"x\":9,\"y\":0},\"K\":{\"x\":10,\"y\":0},\"L\":{\"x\":11,\"y\":0},\"M\":{\"x\":12,\"y\":0},\"N\":{\"x\":13,\"y\":0},\"O\":{\"x\":14,\"y\":0},\"P\":{\"x\":15,\"y\":0},\"Q\":{\"x\":16,\"y\":0},\"R\":{\"x\":17,\"y\":0},\"S\":{\"x\":18,\"y\":0},\"T\":{\"x\":19,\"y\":0},\"U\":{\"x\":20,\"y\":0},\"V\":{\"x\":21,\"y\":0},\"W\":{\"x\":22,\"y\":0},\"X\":{\"x\":23,\"y\":0},\"Y\":{\"x\":24,\"y\":0},\"Z\":{\"x\":25,\"y\":0},\"!\":{\"x\":10,\"y\":1},\"?\":{\"x\":11,\"y\":1},\".\":{\"x\":12,\"y\":1},\",\":{\"x\":13,\"y\":1},\"/\":{\"x\":14,\"y\":1},\"\\\"\":{\"x\":15,\"y\":1}}");


const $3301e8b9890d3481$export$cf9ad17145f68381 = 16;
const $3301e8b9890d3481$export$d677c14a0e5691a9 = (tile)=>{
    switch(tile){
        case 1:
            return {
                x: 1,
                y: 0,
                isWall: true,
                isFood: false
            };
        case 2:
            return {
                x: 2,
                y: 0,
                isWall: true,
                isFood: false
            };
        case 3:
            return {
                x: 3,
                y: 0,
                isWall: true,
                isFood: false
            };
        case 4:
            return {
                x: 4,
                y: 0,
                isWall: true,
                isFood: false
            };
        case 5:
            return {
                x: 5,
                y: 0,
                isWall: true,
                isFood: false
            };
        case 6:
            return {
                x: 6,
                y: 0,
                isWall: true,
                isFood: false
            };
        case 7:
            return {
                x: 7,
                y: 0,
                isWall: true,
                isFood: false
            };
        case 8:
            return {
                x: 8,
                y: 0,
                isWall: true,
                isFood: false
            };
        case 9:
            return {
                x: 9,
                y: 0,
                isWall: true,
                isFood: false
            };
        case 10:
            return {
                x: 10,
                y: 0,
                isWall: true,
                isFood: false
            };
        case 11:
            return {
                x: 11,
                y: 0,
                isWall: true,
                isFood: false
            };
        case 12:
            return {
                x: 12,
                y: 0,
                isWall: true,
                isFood: false
            };
        case 13:
            return {
                x: 0,
                y: 1,
                isWall: true,
                isFood: false
            };
        case 14:
            return {
                x: 1,
                y: 1,
                isWall: true,
                isFood: false
            };
        case 15:
            return {
                x: 2,
                y: 1,
                isWall: true,
                isFood: false
            };
        case 16:
            return {
                x: 3,
                y: 1,
                isWall: true,
                isFood: false
            };
        case 17:
            return {
                x: 4,
                y: 1,
                isWall: true,
                isFood: false
            };
        case 18:
            return {
                x: 5,
                y: 1,
                isWall: true,
                isFood: false
            };
        case 19:
            return {
                x: 6,
                y: 1,
                isWall: true,
                isFood: false
            };
        case 20:
            return {
                x: 7,
                y: 1,
                isWall: true,
                isFood: false
            };
        case 21:
            return {
                x: 8,
                y: 1,
                isWall: true,
                isFood: false
            };
        case 22:
            return {
                x: 9,
                y: 1,
                isWall: true,
                isFood: false
            };
        case 23:
            return {
                x: 10,
                y: 1,
                isWall: true,
                isFood: false
            };
        case 24:
            return {
                x: 11,
                y: 1,
                isWall: true,
                isFood: false
            };
        case 25:
            return {
                x: 12,
                y: 1,
                isWall: true,
                isFood: false
            };
        case 26:
            return {
                x: 0,
                y: 2,
                isWall: true,
                isFood: false
            };
        case 27:
            return {
                x: 1,
                y: 2,
                isWall: true,
                isFood: false
            };
        case 28:
            return {
                x: 2,
                y: 2,
                isWall: true,
                isFood: false
            };
        case 29:
            return {
                x: 3,
                y: 2,
                isWall: true,
                isFood: false
            };
        case 30:
            return {
                x: 4,
                y: 2,
                isWall: true,
                isFood: false
            };
        case 31:
            return {
                x: 5,
                y: 2,
                isWall: true,
                isFood: false
            };
        case 32:
            return {
                x: 6,
                y: 2,
                isWall: true,
                isFood: false
            };
        case 33:
            return {
                x: 7,
                y: 2,
                isWall: true,
                isFood: false
            };
        case 34:
            return {
                x: 8,
                y: 2,
                isWall: true,
                isFood: false
            };
        case 35:
            return {
                x: 9,
                y: 2,
                isWall: true,
                isFood: false
            };
        case 36:
            return {
                x: 10,
                y: 2,
                isWall: true,
                isFood: false
            };
        case 37:
            return {
                x: 11,
                y: 2,
                isWall: false,
                isFood: true
            };
        case 38:
            return {
                x: 12,
                y: 2,
                isWall: false,
                isFood: true,
                isPowerup: true
            };
        case 39:
            return {
                x: 0,
                y: 0,
                isWall: true,
                isFood: false,
                isPowerup: false
            };
        case 0:
        default:
            return {
                x: 0,
                y: 0,
                isWall: false,
                isFood: false
            };
    }
};
class $3301e8b9890d3481$export$2e2bcd8739ae039 {
    get name() {
        return 'maze';
    }
    static positionIsInsideGhostHouse(pos) {
        return false;
    }
    static canMove(newPos, state) {
        const { x: x, y: y } = newPos;
        const { map: map } = state;
        const col = Math.min(x, map[0].length - 1);
        const row = y >= 0 ? Math.min(y, map.length - 1) : map.length - 1;
        const tile = $3301e8b9890d3481$export$d677c14a0e5691a9(map[row][col]);
        return !tile.isWall;
    }
    static getFood(position, state) {
        const { x: x, y: y } = position;
        const col = Math.floor(x);
        const row = Math.floor(y);
        const [food] = state.food.filter((f)=>f.x === col && f.y === row);
        if (!food) return;
        return {
            ...food
        };
    }
    static getTile(position, state) {
        const { x: x, y: y } = position;
        const { map: map } = state;
        const col = Math.floor(x);
        const row = Math.floor(y);
        const { isFood: isFood, isWall: isWall, isPowerup: isPowerup } = $3301e8b9890d3481$export$d677c14a0e5691a9(map[row][col]);
        return {
            col: col,
            row: row,
            isFood: isFood,
            isWall: isWall,
            isPowerup: isPowerup
        };
    }
    static maxX(state) {
        return state.map[0].length - 1;
    }
    static maxY(state) {
        return state.map.length - 1;
    }
    constructor(sprite){
        this.sprite = sprite;
        this.map = [];
        this.food = [];
    }
    update(gameTime, state) {
        this.map = state.map;
        this.food = state.food;
    }
    render(gameTime, ctx) {
        const { map: map, sprite: sprite } = this;
        if (!sprite || !map) return;
        this.map.forEach((row, y)=>{
            row.forEach((column, x)=>{
                const tile = $3301e8b9890d3481$export$d677c14a0e5691a9(column);
                const shouldDraw = !tile.isPowerup || gameTime % 10 === 0;
                if (shouldDraw) ctx.drawImage(sprite.sprite, tile.x * $3301e8b9890d3481$export$cf9ad17145f68381, tile.y * $3301e8b9890d3481$export$cf9ad17145f68381, $3301e8b9890d3481$export$cf9ad17145f68381, $3301e8b9890d3481$export$cf9ad17145f68381, x * $3301e8b9890d3481$export$cf9ad17145f68381, y * $3301e8b9890d3481$export$cf9ad17145f68381, $3301e8b9890d3481$export$cf9ad17145f68381, $3301e8b9890d3481$export$cf9ad17145f68381);
            });
        });
    }
    renderFood(gameTime, ctx) {
        const { map: map, sprite: sprite } = this;
        if (!sprite || !map) return;
        this.food.forEach((f)=>{
            const tile = f.isPowerup ? $3301e8b9890d3481$export$d677c14a0e5691a9(38) : $3301e8b9890d3481$export$d677c14a0e5691a9(37);
            const shouldDraw = !tile.isPowerup || gameTime % 30 < 15;
            if (shouldDraw) ctx.drawImage(sprite.sprite, tile.x * $3301e8b9890d3481$export$cf9ad17145f68381, tile.y * $3301e8b9890d3481$export$cf9ad17145f68381, $3301e8b9890d3481$export$cf9ad17145f68381, $3301e8b9890d3481$export$cf9ad17145f68381, f.x * $3301e8b9890d3481$export$cf9ad17145f68381, f.y * $3301e8b9890d3481$export$cf9ad17145f68381, $3301e8b9890d3481$export$cf9ad17145f68381, $3301e8b9890d3481$export$cf9ad17145f68381);
        });
    }
}


var $aa1db0b089ef7146$export$892596cec99bc70e = /*#__PURE__*/ function(Color) {
    Color[Color["White"] = 0] = "White";
    Color[Color["Yellow"] = 1] = "Yellow";
    Color[Color["Cyan"] = 2] = "Cyan";
    Color[Color["Purple"] = 3] = "Purple";
    Color[Color["Red"] = 4] = "Red";
    Color[Color["Blue"] = 5] = "Blue";
    Color[Color["Green"] = 6] = "Green";
    return Color;
}({});
var $aa1db0b089ef7146$export$80f2abd03de5ca5a = /*#__PURE__*/ function(FontSize) {
    FontSize[FontSize["Small"] = 0] = "Small";
    FontSize[FontSize["Normal"] = 1] = "Normal";
    FontSize[FontSize["Large"] = 2] = "Large";
    return FontSize;
}({});
const $aa1db0b089ef7146$var$BITMAP_WIDTH = 25;
const $aa1db0b089ef7146$var$BITMAP_HEIGHT = 25;
const $aa1db0b089ef7146$var$getChar = (char)=>{
    const fontMap = (0, (/*@__PURE__*/$parcel$interopDefault($037a65334863e5a8$exports)));
    return fontMap[char.toLocaleUpperCase()] ?? {
        x: 25,
        y: 1
    };
};
class $aa1db0b089ef7146$export$2e2bcd8739ae039 {
    constructor(sprite){
        this.sprite = sprite;
        this.bufferCanvas = document.createElement('canvas');
        this.bufferCtx = this.bufferCanvas.getContext('2d');
    }
    getDimensions(size) {
        switch(size){
            case 2:
                return {
                    width: 24,
                    height: 24
                };
            case 1:
                return {
                    width: 16,
                    height: 16
                };
            case 0:
                return {
                    width: 8,
                    height: 8
                };
        }
    }
    renderCharacter(char, size, index, ctx) {
        const { sprite: sprite } = this;
        const { width: width, height: height } = this.getDimensions(size);
        const { x: x, y: y } = $aa1db0b089ef7146$var$getChar(char);
        if (!sprite) return;
        ctx.drawImage(sprite.sprite, $aa1db0b089ef7146$var$BITMAP_WIDTH * x, $aa1db0b089ef7146$var$BITMAP_HEIGHT * y, $aa1db0b089ef7146$var$BITMAP_WIDTH, $aa1db0b089ef7146$var$BITMAP_HEIGHT, index * width, 0, width, width);
    }
    getColor(color) {
        switch(color){
            case 2:
                return '#00ffff';
            case 1:
                return '#ffff00';
            case 4:
                return '#ff0000';
            case 3:
                return '#ff00ff';
            case 5:
                return '#0000ff';
            case 6:
                return '#00ff00';
            case 0:
            default:
                return '#fff';
        }
    }
    renderText(text, size, color, position, ctx) {
        const { bufferCanvas: bufferCanvas, bufferCtx: bufferCtx, sprite: sprite } = this;
        if (!sprite) return;
        const { x: x, y: y } = position;
        ctx.save();
        ctx.translate((0, $3301e8b9890d3481$export$cf9ad17145f68381) * x, (0, $3301e8b9890d3481$export$cf9ad17145f68381) * y);
        const { width: width, height: height } = this.getDimensions(size);
        const chars = text.split('');
        const bufferWidth = chars.length * width;
        this.bufferCanvas.width = bufferWidth;
        this.bufferCanvas.height = height;
        bufferCtx.save();
        bufferCtx.clearRect(0, 0, bufferWidth, height);
        chars.forEach((char, index)=>this.renderCharacter(char, size, index, bufferCtx));
        bufferCtx.fillStyle = this.getColor(color);
        bufferCtx.globalCompositeOperation = "source-in";
        bufferCtx.fillRect(0, 0, bufferWidth, height);
        bufferCtx.restore();
        ctx.drawImage(bufferCanvas, 0, 0);
        ctx.restore();
    }
}






const $fe6364bd783e7bf6$var$CHARACTERS = [
    ' ',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z'
];
var $fe6364bd783e7bf6$export$8e4da1bcc9dc6af = /*#__PURE__*/ function(InputState) {
    InputState[InputState["Disabled"] = 0] = "Disabled";
    InputState[InputState["Pending"] = 1] = "Pending";
    InputState[InputState["Done"] = 2] = "Done";
    return InputState;
}({});
class $fe6364bd783e7bf6$export$2e2bcd8739ae039 {
    get name() {
        return `textInput`;
    }
    get inputState() {
        return this._inputState;
    }
    constructor(textRenderer, pos, onDone, inputState = 0){
        this.onDone = onDone;
        this.cursor = 0;
        this.characters = [
            ' '
        ];
        this._inputState = 0;
        this.textRenderer = textRenderer;
        this.pos = pos;
        this._inputState = inputState;
    }
    move(key) {
        if (this.inputState !== 1) return;
        let index = $fe6364bd783e7bf6$var$CHARACTERS.indexOf(this.characters[this.cursor] || ' ');
        switch(key){
            case (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Down:
                index -= 1;
                if (index < 0) index = $fe6364bd783e7bf6$var$CHARACTERS.length - 1;
                this.characters[this.cursor] = $fe6364bd783e7bf6$var$CHARACTERS[index % $fe6364bd783e7bf6$var$CHARACTERS.length];
                break;
            case (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Up:
                index += 1;
                if (index < 0) index = $fe6364bd783e7bf6$var$CHARACTERS.length - 1;
                this.characters[this.cursor] = $fe6364bd783e7bf6$var$CHARACTERS[index % $fe6364bd783e7bf6$var$CHARACTERS.length];
                break;
            case (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Left:
                if (this.cursor > 0) this.cursor--;
                break;
            case (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Right:
                if (this.cursor < 9) {
                    if (this.characters[this.cursor] === ' ') {
                        this._inputState = 2;
                        this.onDone(this.characters.join('').trim());
                    } else {
                        this.cursor++;
                        if (!this.characters[this.cursor]) this.characters[this.cursor] = ' ';
                    }
                } else {
                    this._inputState = 2;
                    this.onDone(this.characters.join('').trim());
                }
        }
    }
    update(gameTime, state) {}
    render(gameTime, ctx) {
        ctx.save();
        Array.from({
            length: 10
        }).forEach((_, i)=>{
            const char = this.characters[i];
            if (char) {
                if (i === this.cursor && gameTime % 30 < 15 && this.inputState === 1) {
                    ctx.fillStyle = '#fff';
                    ctx.fillRect(this.pos.x * (0, $3301e8b9890d3481$export$cf9ad17145f68381) + 16 * i, this.pos.y * (0, $3301e8b9890d3481$export$cf9ad17145f68381) + (0, $3301e8b9890d3481$export$cf9ad17145f68381), 14, 4);
                }
                this.textRenderer?.renderText(char, (0, $aa1db0b089ef7146$export$80f2abd03de5ca5a).Normal, (0, $aa1db0b089ef7146$export$892596cec99bc70e).White, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(this.pos.x + i, this.pos.y), ctx);
            }
        });
        ctx.restore();
    }
}



class $d3b8ac7c95e71665$export$2e2bcd8739ae039 {
    constructor(screenManager){
        this.name = 'GameOverScreen';
        this.gameObjects = [];
        this.onInput1Done = (name)=>{
            if (this.p1Score) {
                this.p1Score.name = name;
                this.p1Score.timestamp = Date.now();
            }
        };
        this.onInput2Done = (name)=>{
            if (this.p2Score) {
                this.p2Score.name = name;
                this.p2Score.timestamp = Date.now();
            }
        };
        this.screenManager = screenManager;
        this.width = screenManager.width;
        this.height = screenManager.height;
    }
    onPlayerInput(player, key) {
        const { textInput1: textInput1, textInput2: textInput2 } = this;
        if (textInput1 && textInput2) {
            if (player.name === 'player-0') textInput1.move(key);
            if (player.name === 'player-1') textInput2.move(key);
            if (textInput1.inputState !== (0, $fe6364bd783e7bf6$export$8e4da1bcc9dc6af).Pending && textInput2.inputState !== (0, $fe6364bd783e7bf6$export$8e4da1bcc9dc6af).Pending) {
                if (this.p1Score || this.p2Score) (0, $565bb8264fce4bd8$export$61c0464fd40edb58)(this.tempScores ?? []);
                this.screenManager.setScreen((0, $d97f67d971fb3f87$export$a98515d67472a41f).HighScore);
            }
        }
    }
    initScreen(state) {
        const { players: players } = state;
        const [player1, player2] = players;
        this.p1Score = (0, $565bb8264fce4bd8$export$2fcfd70a284e8a97)('#p1', player1?.score ?? 0);
        this.p2Score = (0, $565bb8264fce4bd8$export$2fcfd70a284e8a97)('#p2', player2?.score ?? 0);
        this.tempScores = (0, $565bb8264fce4bd8$export$99f9e493cb5d4ab9)([
            ...(0, $565bb8264fce4bd8$export$3de7d70fb5123830)(),
            this.p1Score,
            this.p2Score
        ]);
        state.reset();
        this.gameObjects = [];
        (0, $75448a1de67727b4$export$cd054587bb4ae1d2)([
            'font'
        ]).then((sprites)=>{
            this.textRenderer = new (0, $aa1db0b089ef7146$export$2e2bcd8739ae039)(sprites.find((s)=>s.name === 'font'));
            this.textInput1 = new (0, $fe6364bd783e7bf6$export$2e2bcd8739ae039)(this.textRenderer, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(3, 28), this.onInput1Done, this.p1Score && (this.tempScores ?? []).indexOf(this.p1Score) !== -1 ? (0, $fe6364bd783e7bf6$export$8e4da1bcc9dc6af).Pending : (0, $fe6364bd783e7bf6$export$8e4da1bcc9dc6af).Disabled);
            this.textInput2 = new (0, $fe6364bd783e7bf6$export$2e2bcd8739ae039)(this.textRenderer, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(40, 28), this.onInput2Done, this.p2Score && (this.tempScores ?? []).indexOf(this.p2Score) !== -1 ? (0, $fe6364bd783e7bf6$export$8e4da1bcc9dc6af).Pending : (0, $fe6364bd783e7bf6$export$8e4da1bcc9dc6af).Disabled);
            this.update(0, state);
        });
    }
    update(gameTime, state) {
        if (gameTime % 2 === 0) this.gameObjects.forEach((obj)=>obj.update(gameTime, state));
    }
    render(_, gameTime, ctx) {
        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, this.width, this.height);
        this.textRenderer?.renderText(`Game over!`, (0, $aa1db0b089ef7146$export$80f2abd03de5ca5a).Large, (0, $aa1db0b089ef7146$export$892596cec99bc70e).White, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(25, 18), ctx);
        if (this.textInput1?.inputState !== (0, $fe6364bd783e7bf6$export$8e4da1bcc9dc6af).Disabled) {
            this.textRenderer?.renderText(`P1 Enter your name`, (0, $aa1db0b089ef7146$export$80f2abd03de5ca5a).Normal, (0, $aa1db0b089ef7146$export$892596cec99bc70e).Cyan, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(3, 26), ctx);
            this.textInput1?.render(gameTime, ctx);
        }
        if (this.textInput2?.inputState !== (0, $fe6364bd783e7bf6$export$8e4da1bcc9dc6af).Disabled) {
            this.textRenderer?.renderText(`P2 Enter your name`, (0, $aa1db0b089ef7146$export$80f2abd03de5ca5a).Normal, (0, $aa1db0b089ef7146$export$892596cec99bc70e).Cyan, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(40, 26), ctx);
            this.textInput2?.render(gameTime, ctx);
        }
        if (this.textInput1?.inputState === (0, $fe6364bd783e7bf6$export$8e4da1bcc9dc6af).Disabled && this.textInput2?.inputState === (0, $fe6364bd783e7bf6$export$8e4da1bcc9dc6af).Disabled) this.textRenderer?.renderText(`Press any button`, (0, $aa1db0b089ef7146$export$80f2abd03de5ca5a).Normal, (0, $aa1db0b089ef7146$export$892596cec99bc70e).Cyan, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(24, 32), ctx);
        ctx.save();
    }
}










const $16adc9a2295ce702$export$cd3742114fc86d93 = (entity, speed, state)=>{
    const { position: position, target: target, direction: direction, nextDirection: nextDirection } = entity;
    let { x: x, y: y } = target;
    const maxX = (0, $3301e8b9890d3481$export$2e2bcd8739ae039).maxX(state);
    const maxY = (0, $3301e8b9890d3481$export$2e2bcd8739ae039).maxY(state);
    if ($16adc9a2295ce702$var$shouldUpdateTarget(entity)) {
        const newDir = (0, $3301e8b9890d3481$export$2e2bcd8739ae039).canMove($16adc9a2295ce702$export$b0fccf1281fd2a1b(nextDirection, target), state) && nextDirection !== direction;
        if (newDir) entity.direction = nextDirection;
        switch(newDir ? nextDirection : direction){
            case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Left:
                x--;
                break;
            case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Right:
                x++;
                break;
            case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Up:
                y--;
                break;
            case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Down:
                y++;
                break;
        }
        if (x < 0) x = maxX;
        else if (x > maxX) x = 0;
        if (y < 0) y = maxY;
        else if (y > maxY) y = 0;
        const newPos = new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(x, y);
        if ((0, $3301e8b9890d3481$export$2e2bcd8739ae039).canMove(newPos, state)) entity.target = newPos;
    } else {
        let { x: x, y: y } = position;
        switch(direction){
            case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Left:
                x -= speed;
                x = Math.max(x, target.x);
                break;
            case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Right:
                x += speed;
                x = Math.min(x, target.x);
                break;
            case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Up:
                y -= speed;
                y = Math.max(y, target.y);
                break;
            case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Down:
                y += speed;
                y = Math.min(y, target.y);
                break;
        }
        if (x < 0) x = maxX;
        else if (x > maxX) x = 0;
        if (y < 0) y = maxY;
        else if (y > maxY) y = 0;
        entity.position = new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(x, y);
    }
};
const $16adc9a2295ce702$var$shouldUpdateTarget = (entity)=>{
    return (0, $59ac15d34719d398$export$2e2bcd8739ae039).isSame(entity.position, entity.target);
};
const $16adc9a2295ce702$export$b0fccf1281fd2a1b = (nextDirection, target)=>{
    let { x: x, y: y } = target;
    switch(nextDirection){
        case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Right:
            x++;
            break;
        case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Left:
            x--;
            break;
        case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Down:
            y++;
            break;
        case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Up:
            y--;
            break;
    }
    return new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(x, y);
};
class $16adc9a2295ce702$export$2e2bcd8739ae039 {
    get originalPosition() {
        return this._originalPosition;
    }
    get position() {
        return this._position;
    }
    set position(value) {
        this._position = value;
    }
    get target() {
        return this._target;
    }
    set target(value) {
        this._target = value;
    }
    get direction() {
        return this._direction;
    }
    set direction(value) {
        this._direction = value;
    }
    get nextDirection() {
        return this._nextDirection;
    }
    set nextDirection(value) {
        this._nextDirection = value;
    }
    get isRespawning() {
        return this._isRespawning;
    }
    set isRespawning(value) {
        this._isRespawning = value;
    }
    get isDead() {
        return this.lives < 1;
    }
    get lives() {
        return this._lives;
    }
    set lives(value) {
        if (value >= 0) this._lives = value;
    }
    get powerupTimer() {
        return this._powerupTimer;
    }
    get hasPowerup() {
        if (this._powerupTimer > 0) this._powerupTimer -= .4;
        return this._powerupTimer > 0;
    }
    set hasPowerup(value) {
        if (value) this._powerupTimer = 500;
        else this._powerupTimer = 0;
    }
    get name() {
        return this._name;
    }
    get score() {
        return this._score;
    }
    set score(score) {
        this._score = score;
    }
    get displayScore() {
        const score = this.score.toString();
        return `${'0000000000'.substr(0, 10 - score.length)}${score}`;
    }
    constructor(_position, _target, _direction, _name){
        this._position = _position;
        this._target = _target;
        this._direction = _direction;
        this._name = _name;
        this._isRespawning = false;
        this._lives = 0;
        this._powerupTimer = 0;
        this._score = 0;
        this._nextDirection = _direction;
        this._originalPosition = _position;
    }
}



const $4f0f6b7f11a37e3f$var$TILE_SIZE = 32;
const $4f0f6b7f11a37e3f$var$GET_OUT_OF_HOUSE = [
    new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(13.5, 15),
    new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(13.5, 11)
];
let $4f0f6b7f11a37e3f$var$tempTarget = null;
var $4f0f6b7f11a37e3f$export$c525fd6e2e776d77 = /*#__PURE__*/ function(ChaseMode) {
    ChaseMode[ChaseMode["Chase"] = 0] = "Chase";
    ChaseMode[ChaseMode["Scatter"] = 1] = "Scatter";
    ChaseMode[ChaseMode["Frightened"] = 2] = "Frightened";
    return ChaseMode;
}({});
const $4f0f6b7f11a37e3f$var$checkPosition = (ghost, state)=>{
    if (ghost.isDead) {
        if ((0, $59ac15d34719d398$export$2e2bcd8739ae039).isSame(ghost.position, ghost.originalPosition)) {
            ghost.lives = 1;
            $4f0f6b7f11a37e3f$var$tempTarget = null;
        }
    } else {
        if ($4f0f6b7f11a37e3f$var$tempTarget && (0, $59ac15d34719d398$export$2e2bcd8739ae039).isSame(ghost.position, $4f0f6b7f11a37e3f$var$tempTarget)) $4f0f6b7f11a37e3f$var$tempTarget = null;
        state.players.forEach((player)=>{
            if ((0, $59ac15d34719d398$export$2e2bcd8739ae039).isSame(player.target, ghost.target)) {
                if (player.hasPowerup) {
                    ghost.lives = 0;
                    player.score += 200;
                } else if (!player.isRespawning) {
                    player.lives--;
                    player.isRespawning = true;
                }
            }
        });
    }
};
class $4f0f6b7f11a37e3f$export$c0bd6680a351a7b4 {
    get name() {
        return 'ghost';
    }
    constructor(sprite, delay = 0){
        this.sprite = sprite;
        this.delay = delay;
        this.frame = 0;
        this.isDead = false;
        this.isFrightened = false;
        this.isFlashing = false;
        this.forcePath = [];
    }
    getClosestTarget(state) {
        const ghost = this.getGhost(state);
        let target = ghost.position;
        let minDistance = Infinity;
        state.players.filter((player)=>!player.isRespawning && !player.isDead).forEach((player)=>{
            const distance = Math.abs(ghost.position.x - player.position.x) + Math.abs(ghost.position.y - player.position.y);
            if (distance < minDistance) {
                minDistance = distance;
                target = player.position;
            }
        });
        return target;
    }
    getNextDirection(mode, forceMove, shouldMakeDecision, canMoveInCurrentDirection, canMoveLeft, canMoveRight, canMoveUp, canMoveDown, isMovingX, isMovingY, state) {
        // const {
        //   player
        // } = state;
        const ghost = this.getGhost(state);
        const { direction: direction, position: position, isDead: isDead, originalPosition: originalPosition } = ghost;
        let nextDirection = direction;
        const isFrightened = mode === 2 && !isDead;
        const isInGhostHouse = (0, $3301e8b9890d3481$export$2e2bcd8739ae039).positionIsInsideGhostHouse(position);
        if (isInGhostHouse && !this.forcePath.length) this.forcePath = [
            ...$4f0f6b7f11a37e3f$var$GET_OUT_OF_HOUSE
        ];
        if (shouldMakeDecision) {
            let target;
            if (isDead) target = originalPosition;
            else if (this.forcePath.length && !(0, $59ac15d34719d398$export$2e2bcd8739ae039).isSame(position, this.forcePath[this.forcePath.length - 1])) target = this.forcePath.shift();
            else target = $4f0f6b7f11a37e3f$var$tempTarget || this.getTarget(mode, state);
            // const target = !isDead ? (tempTarget || this.getTarget(mode, state)) : TARGET_WHEN_DEAD;
            let options = [];
            if (canMoveInCurrentDirection) options.push(direction);
            if (isMovingX) {
                if (canMoveUp) options.push((0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Up);
                if (canMoveDown) options.push((0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Down);
                if (forceMove) {
                    if (canMoveLeft && direction !== (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Left) options.push((0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Left);
                    if (canMoveDown && direction !== (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Right) options.push((0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Right);
                }
            }
            if (isMovingY) {
                if (canMoveLeft) options.push((0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Left);
                if (canMoveRight) options.push((0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Right);
                if (forceMove) {
                    if (canMoveUp && direction !== (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Up) options.push((0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Up);
                    if (canMoveDown && direction !== (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Down) options.push((0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Down);
                }
            }
            // Last resort bailout!
            if (!options.length) {
                options.push((0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Left);
                options.push((0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Right);
                options.push((0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Up);
                options.push((0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Down);
            }
            let distance = 0;
            options.forEach((dir)=>{
                const { x: x, y: y } = (0, $16adc9a2295ce702$export$b0fccf1281fd2a1b)(dir, ghost.target);
                const dx = target.x - x;
                const dy = target.y - y;
                const dist = Math.sqrt(dx * dx + dy * dy);
                const isCloser = dist <= distance;
                const isFarther = dist >= distance;
                if (!distance || (isFrightened && !isDead ? isFarther : isCloser)) {
                    distance = dist;
                    nextDirection = dir;
                }
            });
        }
        if (!isDead && !isInGhostHouse && (0, $3301e8b9890d3481$export$2e2bcd8739ae039).positionIsInsideGhostHouse((0, $16adc9a2295ce702$export$b0fccf1281fd2a1b)(nextDirection, position))) return direction;
        return nextDirection;
    }
    getSpeed() {
        const { isFrightened: isFrightened } = this;
        if (isFrightened) return .2;
        return .5;
    }
    update(gameTime, state) {
        if (this.delay > gameTime) return;
        const ghost = this.getGhost(state);
        this.originalPos = ghost.originalPosition;
        const [powerfulPlayer] = state.players.filter((p)=>p.hasPowerup);
        this.isDead = ghost.isDead;
        this.isFrightened = powerfulPlayer && !this.isDead;
        this.isFlashing = powerfulPlayer && powerfulPlayer.powerupTimer < 20;
        (0, $16adc9a2295ce702$export$cd3742114fc86d93)(this.getGhost(state), this.getSpeed(), state);
        const { position: position } = this;
        if (position) {
            if (ghost.position.x !== position.x || ghost.position.y !== position.y) this.frame++;
        }
        this.position = ghost.position;
        this.direction = ghost.direction;
        // this.isPlayerDead = state.player1.isDead;
        this.updateDirection(ghost, state);
    }
    updateDirection(ghost, state) {
        const { direction: direction, target: target } = ghost;
        const { isFrightened: isFrightened } = this;
        const [powerfulPlayer] = state.players.filter((p)=>p.hasPowerup);
        const forceMove = powerfulPlayer && powerfulPlayer.powerupTimer >= 50;
        const canMoveInCurrentDirection = (0, $3301e8b9890d3481$export$2e2bcd8739ae039).canMove((0, $16adc9a2295ce702$export$b0fccf1281fd2a1b)(direction, target), state);
        const isMovingX = direction === (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Left || direction === (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Right;
        const isMovingY = direction === (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Up || direction === (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Down;
        const canMoveLeft = (forceMove || direction !== (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Right) && (0, $3301e8b9890d3481$export$2e2bcd8739ae039).canMove((0, $16adc9a2295ce702$export$b0fccf1281fd2a1b)((0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Left, target), state);
        const canMoveRight = (forceMove || direction !== (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Left) && (0, $3301e8b9890d3481$export$2e2bcd8739ae039).canMove((0, $16adc9a2295ce702$export$b0fccf1281fd2a1b)((0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Right, target), state);
        const canMoveUp = (forceMove || direction !== (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Down) && (0, $3301e8b9890d3481$export$2e2bcd8739ae039).canMove((0, $16adc9a2295ce702$export$b0fccf1281fd2a1b)((0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Up, target), state);
        const canMoveDown = (forceMove || direction !== (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Up) && (0, $3301e8b9890d3481$export$2e2bcd8739ae039).canMove((0, $16adc9a2295ce702$export$b0fccf1281fd2a1b)((0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Down, target), state);
        const canMoveX = isMovingX && canMoveInCurrentDirection || !isMovingX && (canMoveLeft || canMoveRight);
        const canMoveY = isMovingY && canMoveInCurrentDirection || !isMovingY && (canMoveUp || canMoveDown);
        const shouldMakeDecision = !canMoveInCurrentDirection || isMovingX && canMoveY || isMovingY && canMoveX;
        const mode = isFrightened ? 2 : 0;
        ghost.nextDirection = this.getNextDirection(mode, forceMove, shouldMakeDecision, canMoveInCurrentDirection, canMoveLeft, canMoveRight, canMoveUp, canMoveDown, isMovingX, isMovingY, state);
        $4f0f6b7f11a37e3f$var$checkPosition(ghost, state);
    }
    getFrame() {
        const { direction: direction, isFrightened: isFrightened, isDead: isDead, isFlashing: isFlashing } = this;
        let anim = [
            0,
            1
        ];
        if (!isDead && isFrightened) {
            if (isFlashing) anim = [
                0,
                1,
                2,
                3
            ];
            else anim = [
                0,
                1
            ];
        } else switch(direction){
            case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Right:
                anim = !isDead ? [
                    0,
                    1
                ] : [
                    4
                ];
                break;
            case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Left:
                anim = !isDead ? [
                    2,
                    3
                ] : [
                    5
                ];
                break;
            case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Up:
                anim = !isDead ? [
                    4,
                    5
                ] : [
                    6
                ];
                break;
            case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Down:
                anim = !isDead ? [
                    6,
                    7
                ] : [
                    7
                ];
                break;
        }
        return anim[this.frame % anim.length];
    }
    render(gameTime, ctx) {
        const { isDead: isDead, isFrightened: isFrightened, position: position, sprite: sprite } = this;
        if (!sprite || !position) return;
        const { x: x, y: y } = position;
        let xPos = x * 16 - 8;
        let yPos = y * 16 - 8;
        ctx.save();
        ctx.translate(xPos, yPos);
        ctx.drawImage(sprite.sprite, $4f0f6b7f11a37e3f$var$TILE_SIZE * this.getFrame(), isDead || isFrightened ? $4f0f6b7f11a37e3f$var$TILE_SIZE * 4 : $4f0f6b7f11a37e3f$var$TILE_SIZE * this.getSpriteOffset(), $4f0f6b7f11a37e3f$var$TILE_SIZE, $4f0f6b7f11a37e3f$var$TILE_SIZE, 0, 0, $4f0f6b7f11a37e3f$var$TILE_SIZE, $4f0f6b7f11a37e3f$var$TILE_SIZE);
        ctx.restore();
    }
}


class $29646b40717f7b15$export$2e2bcd8739ae039 extends (0, $4f0f6b7f11a37e3f$export$c0bd6680a351a7b4) {
    getSpriteOffset() {
        return 0;
    }
    getGhost(state) {
        const [blinky] = state.ghosts.filter((g)=>g.name === 'blinky');
        return blinky;
    }
    getTarget(mode, state) {
        switch(mode){
            case (0, $4f0f6b7f11a37e3f$export$c525fd6e2e776d77).Chase:
            case (0, $4f0f6b7f11a37e3f$export$c525fd6e2e776d77).Frightened:
                return this.getClosestTarget(state);
        }
        return this.getGhost(state).position;
    }
}



class $58a77800f04b5b9f$export$2e2bcd8739ae039 extends (0, $4f0f6b7f11a37e3f$export$c0bd6680a351a7b4) {
    getSpriteOffset() {
        return 3;
    }
    getGhost(state) {
        const [clyde] = state.ghosts.filter((g)=>g.name === 'clyde');
        return clyde;
    }
    getTarget(mode, state) {
        switch(mode){
            case (0, $4f0f6b7f11a37e3f$export$c525fd6e2e776d77).Chase:
            case (0, $4f0f6b7f11a37e3f$export$c525fd6e2e776d77).Frightened:
                return this.getClosestTarget(state);
        }
        return this.getGhost(state).position;
    }
}



class $c6fc38c75f7977e8$export$2e2bcd8739ae039 extends (0, $4f0f6b7f11a37e3f$export$c0bd6680a351a7b4) {
    getSpriteOffset() {
        return 2;
    }
    getGhost(state) {
        const [inky] = state.ghosts.filter((g)=>g.name === 'inky');
        return inky;
    }
    getTarget(mode, state) {
        switch(mode){
            case (0, $4f0f6b7f11a37e3f$export$c525fd6e2e776d77).Chase:
            case (0, $4f0f6b7f11a37e3f$export$c525fd6e2e776d77).Frightened:
                return this.getClosestTarget(state);
        }
        return this.getGhost(state).position;
    }
}






const $01273d359e75d9ee$export$cf9ad17145f68381 = 32;
const $01273d359e75d9ee$var$SPEED = .5;
const $01273d359e75d9ee$var$checkPosition = (state, player)=>{
    const { position: position } = player;
    const food = (0, $3301e8b9890d3481$export$2e2bcd8739ae039).getFood(position, state);
    // TODO: Give powerup + score to right player
    if (food) {
        if (food.isPowerup) {
            player.hasPowerup = true;
            player.score += 50;
        } else player.score += 10;
        state.eatFood(new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(food.x, food.y));
    }
    if (player.hasPowerup) state.players.filter((p)=>!p.hasPowerup && p !== player).forEach((p)=>{
        if ((0, $59ac15d34719d398$export$2e2bcd8739ae039).isSame(p.target, player.target)) {
            if (!p.isRespawning) {
                p.lives--;
                p.isRespawning = true;
                player.score += 200;
            }
        }
    });
};
class $01273d359e75d9ee$export$2e2bcd8739ae039 {
    get name() {
        return `player-${this._player}`;
    }
    constructor(sprite, _player){
        this.sprite = sprite;
        this._player = _player;
        this.frame = 0;
        this.isRespawning = false;
        this.bufferCanvas = document.createElement('canvas');
        this.bufferCtx = this.bufferCanvas.getContext('2d');
    }
    getFrame() {
        const { frame: frame, isRespawning: isRespawning } = this;
        let anim = [
            1,
            2,
            3
        ];
        let frameSpeed = .5;
        if (isRespawning && this.state) {
            anim = [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ];
            frameSpeed = .2;
            this.state.players[this._player].isRespawning = true;
        }
        let showFrame = Math.floor(frame * frameSpeed) % anim.length;
        if (isRespawning && anim[showFrame] === 14) this.state?.respawnPlayer(this._player);
        return anim[showFrame];
    }
    update(gameTime, state) {
        const player = state.players[this._player];
        if (player.isDead) return;
        const { position: position } = this;
        const { isRespawning: isRespawning } = player;
        if (!isRespawning) (0, $16adc9a2295ce702$export$cd3742114fc86d93)(player, $01273d359e75d9ee$var$SPEED, state);
        if (position) {
            if (isRespawning || player.position.x !== position.x || player.position.y !== position.y) this.frame++;
        }
        if (isRespawning && !this.isRespawning) this.frame = 0;
        this.position = player.position;
        this.direction = player.direction;
        this.isRespawning = isRespawning;
        this.state = state;
        $01273d359e75d9ee$var$checkPosition(state, player);
    }
    render(gameTime, ctx) {
        const { position: position, sprite: sprite, isRespawning: isRespawning } = this;
        const player = this.state?.players[this._player];
        if (!sprite || !position || player?.isDead) return;
        const { x: x, y: y } = position;
        let xPos = x * 16 - 8;
        let yPos = y * 16 - 8;
        ctx.save();
        ctx.translate(xPos, yPos);
        let offsetX = 0;
        let offsetY = 0;
        if (!isRespawning) switch(this.direction){
            case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Right:
                ctx.rotate(0);
                break;
            case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Left:
                ctx.rotate(180 * (Math.PI / 180));
                offsetX = -32;
                offsetY = -32;
                break;
            case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Down:
                ctx.rotate(90 * (Math.PI / 180));
                offsetY = -32;
                break;
            case (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Up:
                ctx.rotate(-90 * (Math.PI / 180));
                offsetX = -32;
                break;
        }
        const shouldFlash = player?.hasPowerup && gameTime % 30 < 15;
        const { bufferCtx: bufferCtx } = this;
        bufferCtx.save();
        bufferCtx.clearRect(0, 0, $01273d359e75d9ee$export$cf9ad17145f68381, $01273d359e75d9ee$export$cf9ad17145f68381);
        bufferCtx.drawImage(sprite.sprite, $01273d359e75d9ee$export$cf9ad17145f68381 * this.getFrame(), 0, $01273d359e75d9ee$export$cf9ad17145f68381, $01273d359e75d9ee$export$cf9ad17145f68381, 0, 0, $01273d359e75d9ee$export$cf9ad17145f68381, $01273d359e75d9ee$export$cf9ad17145f68381);
        if (shouldFlash) {
            bufferCtx.fillStyle = '#2532fb';
            bufferCtx.globalCompositeOperation = 'source-in';
            bufferCtx.fillRect(0, 0, $01273d359e75d9ee$export$cf9ad17145f68381, $01273d359e75d9ee$export$cf9ad17145f68381);
        }
        bufferCtx.restore();
        ctx.drawImage(this.bufferCanvas, offsetX, offsetY);
        ctx.restore();
    }
}



class $b1b691cabc1063e9$export$2e2bcd8739ae039 extends (0, $4f0f6b7f11a37e3f$export$c0bd6680a351a7b4) {
    getSpriteOffset() {
        return 1;
    }
    getGhost(state) {
        const [pinky] = state.ghosts.filter((g)=>g.name === 'pinky');
        return pinky;
    }
    getTarget(mode, state) {
        switch(mode){
            case (0, $4f0f6b7f11a37e3f$export$c525fd6e2e776d77).Chase:
            case (0, $4f0f6b7f11a37e3f$export$c525fd6e2e776d77).Frightened:
                return this.getClosestTarget(state);
        }
        return this.getGhost(state).position;
    }
}



class $3b0cf3dc2d95fe04$export$2e2bcd8739ae039 {
    get name() {
        return 'Lifebar';
    }
    constructor(sprite, _player, position){
        this.sprite = sprite;
        this._player = _player;
        this.position = position;
        this.lives = 0;
    }
    update(gameTime, state) {
        this.lives = state.players[this._player].lives;
    }
    render(gameTime, ctx) {
        const { sprite: sprite, lives: lives } = this;
        if (!sprite || !lives) return;
        ctx.save();
        ctx.translate(this.position.x * 16, this.position.y * 16);
        for(let i = lives; i > 0; i--)ctx.drawImage(sprite.sprite, (0, $01273d359e75d9ee$export$cf9ad17145f68381) * 1, 0, (0, $01273d359e75d9ee$export$cf9ad17145f68381), (0, $01273d359e75d9ee$export$cf9ad17145f68381), (0, $01273d359e75d9ee$export$cf9ad17145f68381) * i - (0, $01273d359e75d9ee$export$cf9ad17145f68381), 0, (0, $01273d359e75d9ee$export$cf9ad17145f68381), (0, $01273d359e75d9ee$export$cf9ad17145f68381));
        ctx.restore();
    }
}





class $09e99dc258373ab1$export$2e2bcd8739ae039 {
    constructor(screenManager){
        this.name = 'GameScreen';
        this.gameObjects = [];
        this.screenManager = screenManager;
        this.width = screenManager.width;
        this.height = screenManager.height;
        this.mazeCanvas = document.createElement('canvas');
        this.mazeCanvas.width = this.width;
        this.mazeCanvas.height = this.height;
        this.mazeCtx = this.mazeCanvas.getContext('2d');
    }
    onPlayerInput(player, key, state) {
        if (state.gameState !== (0, $3b35f402ec1d6958$export$eb5ccdbd077479c).Playing) return;
        switch(key){
            case (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Up:
                player.nextDirection = (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Up;
                break;
            case (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Down:
                player.nextDirection = (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Down;
                break;
            case (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Left:
                player.nextDirection = (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Left;
                break;
            case (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Right:
                player.nextDirection = (0, $3b35f402ec1d6958$export$cacd6541cfeeb6c1).Right;
                break;
        }
    }
    initScreen(state) {
        state.reset();
        this.initLevel(state);
    }
    initLevel(state) {
        this.gameObjects = [];
        (0, $75448a1de67727b4$export$cd054587bb4ae1d2)([
            'pacman',
            'redman',
            'sprites',
            'ghosts',
            'font'
        ]).then((sprites)=>{
            this.gameObjects.push(new (0, $3301e8b9890d3481$export$2e2bcd8739ae039)(sprites.find((s)=>s.name === 'sprites')));
            this.gameObjects.push(new (0, $01273d359e75d9ee$export$2e2bcd8739ae039)(sprites.find((s)=>s.name === 'pacman'), 0));
            this.gameObjects.push(new (0, $01273d359e75d9ee$export$2e2bcd8739ae039)(sprites.find((s)=>s.name === 'redman'), 1));
            this.gameObjects.push(new (0, $29646b40717f7b15$export$2e2bcd8739ae039)(sprites.find((s)=>s.name === 'ghosts')));
            this.gameObjects.push(new (0, $b1b691cabc1063e9$export$2e2bcd8739ae039)(sprites.find((s)=>s.name === 'ghosts')));
            this.gameObjects.push(new (0, $c6fc38c75f7977e8$export$2e2bcd8739ae039)(sprites.find((s)=>s.name === 'ghosts'), 300));
            this.gameObjects.push(new (0, $58a77800f04b5b9f$export$2e2bcd8739ae039)(sprites.find((s)=>s.name === 'ghosts'), 300));
            this.gameObjects.push(new (0, $3b0cf3dc2d95fe04$export$2e2bcd8739ae039)(sprites.find((s)=>s.name === 'pacman'), 0, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(1, 35)));
            this.gameObjects.push(new (0, $3b0cf3dc2d95fe04$export$2e2bcd8739ae039)(sprites.find((s)=>s.name === 'redman'), 1, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(49, 35)));
            this.textRenderer = new (0, $aa1db0b089ef7146$export$2e2bcd8739ae039)(sprites.find((s)=>s.name === 'font'));
            this.update(0, state);
            this.preRenderMaze(0, this.mazeCtx);
        });
    }
    /**
   * Pre-render maze for performance
   */ preRenderMaze(gameTime, ctx) {
        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, this.width, this.height);
        ctx.save();
        this.gameObjects.filter((obj)=>obj.name === 'maze').forEach((obj)=>obj.render(gameTime, ctx));
        ctx.restore();
    }
    update(gameTime, state) {
        if (gameTime >= 100 && state.gameState === (0, $3b35f402ec1d6958$export$eb5ccdbd077479c).Ready) state.gameState = (0, $3b35f402ec1d6958$export$eb5ccdbd077479c).Playing;
        if (gameTime % 2 === 0) this.gameObjects.forEach((obj)=>obj.update(gameTime, state));
        if (state.isGameOver()) this.screenManager.setScreen((0, $d97f67d971fb3f87$export$a98515d67472a41f).GameOver);
    }
    render(state, gameTime, ctx) {
        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, this.width, this.height);
        ctx.drawImage(this.mazeCanvas, 0, 0);
        this.gameObjects.filter((obj)=>obj.name === 'maze').forEach((obj)=>obj.renderFood(gameTime, ctx));
        this.textRenderer?.renderText(`P1 ${state.players[0].displayScore}`, (0, $aa1db0b089ef7146$export$80f2abd03de5ca5a).Normal, (0, $aa1db0b089ef7146$export$892596cec99bc70e).White, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(1, 1), ctx);
        this.textRenderer?.renderText(`P2 ${state.players[1].displayScore}`, (0, $aa1db0b089ef7146$export$80f2abd03de5ca5a).Normal, (0, $aa1db0b089ef7146$export$892596cec99bc70e).White, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(49, 1), ctx);
        ctx.save();
        const { gameObjects: gameObjects } = this;
        if (state.gameState === (0, $3b35f402ec1d6958$export$eb5ccdbd077479c).Playing) gameObjects.filter((obj)=>obj.name !== 'maze').forEach((obj)=>obj.render(gameTime, ctx));
        else gameObjects.filter((obj)=>obj.name !== 'maze' && obj.name !== 'ghost' && obj.name !== 'pacman').forEach((obj)=>obj.render(gameTime, ctx));
        ctx.restore();
        switch(state.gameState){
            case (0, $3b35f402ec1d6958$export$eb5ccdbd077479c).Ready:
                this.textRenderer?.renderText('ready!', (0, $aa1db0b089ef7146$export$80f2abd03de5ca5a).Normal, (0, $aa1db0b089ef7146$export$892596cec99bc70e).Yellow, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(29.5, 18.1), ctx);
                break;
            case (0, $3b35f402ec1d6958$export$eb5ccdbd077479c).Playing:
                if (gameTime < 200) this.textRenderer?.renderText('go!', (0, $aa1db0b089ef7146$export$80f2abd03de5ca5a).Normal, (0, $aa1db0b089ef7146$export$892596cec99bc70e).Yellow, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(30.5, 18.1), ctx);
                break;
            case (0, $3b35f402ec1d6958$export$eb5ccdbd077479c).Paused:
                this.textRenderer?.renderText('paused!', (0, $aa1db0b089ef7146$export$80f2abd03de5ca5a).Normal, (0, $aa1db0b089ef7146$export$892596cec99bc70e).Yellow, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(29, 18.1), ctx);
                break;
        }
    }
}







const $81d5f5c4c96dce0f$var$getPrefix = (index)=>index === 0 ? '1st' : index === 1 ? '2nd' : index === 2 ? '3rd' : index === 3 ? '4th' : index === 4 ? '5th' : '';
const $81d5f5c4c96dce0f$var$getColor = (index)=>index === 0 ? (0, $aa1db0b089ef7146$export$892596cec99bc70e).Red : index === 1 ? (0, $aa1db0b089ef7146$export$892596cec99bc70e).Yellow : index === 2 ? (0, $aa1db0b089ef7146$export$892596cec99bc70e).Green : index === 3 ? (0, $aa1db0b089ef7146$export$892596cec99bc70e).Cyan : index === 4 ? (0, $aa1db0b089ef7146$export$892596cec99bc70e).Blue : (0, $aa1db0b089ef7146$export$892596cec99bc70e).Purple;
class $81d5f5c4c96dce0f$export$2e2bcd8739ae039 {
    constructor(screenManager){
        this.name = 'HighScoreScreen';
        this.gameObjects = [];
        this.screenManager = screenManager;
        this.width = screenManager.width;
        this.height = screenManager.height;
    }
    onPlayerInput() {
        this.screenManager.setScreen((0, $d97f67d971fb3f87$export$a98515d67472a41f).Game);
    }
    initScreen(state) {
        this.highScores = (0, $565bb8264fce4bd8$export$99f9e493cb5d4ab9)().map((s)=>({
                ...s,
                isNew: Date.now() - s.timestamp < 10000
            }));
        state.reset();
        this.gameObjects = [];
        (0, $75448a1de67727b4$export$cd054587bb4ae1d2)([
            'font'
        ]).then((sprites)=>{
            this.textRenderer = new (0, $aa1db0b089ef7146$export$2e2bcd8739ae039)(sprites.find((s)=>s.name === 'font'));
            this.update(0, state);
        });
    }
    update(gameTime, state) {
        if (gameTime % 2 === 0) this.gameObjects.forEach((obj)=>obj.update(gameTime, state));
    }
    render(_, gameTime, ctx) {
        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, this.width, this.height);
        this.textRenderer?.renderText(`Hi score!`, (0, $aa1db0b089ef7146$export$80f2abd03de5ca5a).Large, (0, $aa1db0b089ef7146$export$892596cec99bc70e).White, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(25.5, 4), ctx);
        this.highScores?.forEach((entry, i)=>{
            if (!entry.isNew || gameTime % 30 < 15) this.textRenderer?.renderText(`${$81d5f5c4c96dce0f$var$getPrefix(i)} ${entry.name.substr(0, 20).padEnd(20, ' ')}  ${entry.score.toString().padStart(7, ' ')}`, (0, $aa1db0b089ef7146$export$80f2abd03de5ca5a).Large, $81d5f5c4c96dce0f$var$getColor(i), new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(7, 10 + i * 4), ctx);
        });
        this.textRenderer?.renderText(`Press any button`, (0, $aa1db0b089ef7146$export$80f2abd03de5ca5a).Normal, (0, $aa1db0b089ef7146$export$892596cec99bc70e).Cyan, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(24, 32), ctx);
        ctx.save();
    }
}






class $43f205e0427f004b$export$2e2bcd8739ae039 {
    constructor(screenManager){
        this.name = 'IntroScreen';
        this.gameObjects = [];
        this.screenManager = screenManager;
        this.width = screenManager.width;
        this.height = screenManager.height;
    }
    onPlayerInput(player, key) {
        this.screenManager.setScreen((0, $d97f67d971fb3f87$export$a98515d67472a41f).HighScore);
    }
    initScreen(state) {
        state.reset();
        this.gameObjects = [];
        (0, $75448a1de67727b4$export$cd054587bb4ae1d2)([
            'font'
        ]).then((sprites)=>{
            this.textRenderer = new (0, $aa1db0b089ef7146$export$2e2bcd8739ae039)(sprites.find((s)=>s.name === 'font'));
            this.update(0, state);
        });
    }
    update(gameTime, state) {
        if (gameTime % 2 === 0) this.gameObjects.forEach((obj)=>obj.update(gameTime, state));
        if (gameTime > 100) this.screenManager.setScreen((0, $d97f67d971fb3f87$export$a98515d67472a41f).HighScore);
    }
    render(_, gameTime, ctx) {
        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, this.width, this.height);
        this.textRenderer?.renderText(`Pac Man Arena`, (0, $aa1db0b089ef7146$export$80f2abd03de5ca5a).Large, (0, $aa1db0b089ef7146$export$892596cec99bc70e).Yellow, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(22.5, 12), ctx);
        this.textRenderer?.renderText(`By Oscar Wallhult`, (0, $aa1db0b089ef7146$export$80f2abd03de5ca5a).Normal, (0, $aa1db0b089ef7146$export$892596cec99bc70e).White, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(23.6, 34), ctx);
        ctx.save();
    }
}


var $d97f67d971fb3f87$export$a98515d67472a41f = /*#__PURE__*/ function(Screen) {
    Screen[Screen["Intro"] = 0] = "Intro";
    Screen[Screen["Game"] = 1] = "Game";
    Screen[Screen["GameOver"] = 2] = "GameOver";
    Screen[Screen["HighScore"] = 3] = "HighScore";
    return Screen;
}({});
class $d97f67d971fb3f87$export$cabb9ed6ac90bb6 {
    constructor(state, width, height){
        this.currentScreen = 0;
        this.state = state;
        this.width = width;
        this.height = height;
        this.introScreen = new (0, $43f205e0427f004b$export$2e2bcd8739ae039)(this);
        this.gameScreen = new (0, $09e99dc258373ab1$export$2e2bcd8739ae039)(this);
        this.gameOverScreen = new (0, $d3b8ac7c95e71665$export$2e2bcd8739ae039)(this);
        this.highScoreScreen = new (0, $81d5f5c4c96dce0f$export$2e2bcd8739ae039)(this);
        this.onChangeScreen();
    }
    onChangeScreen() {
        this.getCurrentScreen().initScreen(this.state);
    }
    getCurrentScreen() {
        switch(this.currentScreen){
            case 0:
                return this.introScreen;
            case 1:
                return this.gameScreen;
            case 3:
                return this.highScoreScreen;
            case 2:
            default:
                return this.gameOverScreen;
        }
    }
    setScreen(screen) {
        this.currentScreen = screen;
        this.onChangeScreen();
    }
}





var $8c635492ff8c26eb$exports = {};
$8c635492ff8c26eb$exports = JSON.parse("{\"name\":\"Level 1\",\"maze\":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,12,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,10,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[5,9,0,7,9,0,7,8,8,8,8,8,9,0,7,8,9,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,7,8,9,0,7,8,8,8,8,8,9,0,7,9,0,7,5],[0,13,0,15,16,0,10,11,11,21,22,11,12,0,10,11,12,0,10,2,2,2,2,2,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,2,2,2,2,2,12,0,10,11,12,0,10,11,21,22,11,11,12,0,15,16,0,14,0],[0,13,0,15,16,0,0,0,0,15,16,0,0,0,0,0,0,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,0,0,0,0,0,0,15,16,0,0,0,0,15,16,0,14,0],[0,13,0,15,16,0,7,9,0,10,12,0,7,8,8,8,9,0,7,8,8,8,9,0,10,2,2,2,2,2,2,2,2,2,2,2,2,2,2,12,0,7,8,8,8,9,0,7,8,8,8,9,0,10,12,0,7,9,0,15,16,0,14,0],[0,13,0,15,16,0,15,16,0,0,0,0,15,22,11,11,12,0,10,11,11,11,12,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10,11,11,11,12,0,10,11,11,21,16,0,0,0,0,15,16,0,15,16,0,14,0],[0,13,0,15,16,0,15,16,0,7,9,0,15,16,0,0,0,0,0,0,0,0,0,0,7,8,8,8,8,8,8,8,8,8,8,8,8,8,8,9,0,0,0,0,0,0,0,0,0,0,15,16,0,7,9,0,15,16,0,15,16,0,14,0],[0,13,0,15,16,0,15,16,0,15,16,0,15,16,0,7,8,8,8,8,8,8,9,0,15,22,11,11,11,11,11,11,11,11,11,11,11,11,21,16,0,7,8,8,8,8,8,8,9,0,15,16,0,15,16,0,15,16,0,15,16,0,14,0],[0,13,0,15,16,0,15,16,0,10,12,0,15,16,0,15,22,11,11,11,11,11,12,0,15,16,0,0,0,0,0,0,0,0,0,0,0,0,15,16,0,10,11,11,11,11,11,21,16,0,15,16,0,10,12,0,15,16,0,15,16,0,14,0],[0,13,0,15,16,0,15,16,0,0,0,0,15,16,0,15,16,0,0,0,0,0,0,0,15,16,0,7,8,8,8,8,8,8,8,8,9,0,15,16,0,0,0,0,0,0,0,15,16,0,15,16,0,0,0,0,15,16,0,15,16,0,14,0],[0,13,0,10,12,0,15,16,0,7,9,0,15,16,0,15,16,0,7,8,8,8,9,0,15,16,0,15,0,0,0,0,0,0,0,0,16,0,15,16,0,7,8,8,8,9,0,15,16,0,15,16,0,7,9,0,15,16,0,10,12,0,14,0],[0,13,0,0,0,0,15,16,0,15,16,0,15,16,0,15,16,0,15,0,0,0,16,0,15,16,0,15,0,0,0,0,0,0,0,0,16,0,15,16,0,15,0,0,0,16,0,15,16,0,15,16,0,15,16,0,15,16,0,0,0,0,14,0],[0,4,5,5,9,0,15,16,0,15,16,0,15,16,0,15,16,0,15,0,0,0,16,0,15,16,0,15,0,0,0,0,0,0,0,0,16,0,15,16,0,15,0,0,0,16,0,15,16,0,15,16,0,15,16,0,15,16,0,7,5,5,6,0],[2,2,2,2,12,0,10,12,0,10,12,0,10,12,0,15,16,0,10,11,11,11,12,0,10,12,0,10,11,11,11,11,11,11,11,11,12,0,10,12,0,10,11,11,11,12,0,15,16,0,10,12,0,10,12,0,10,12,0,10,2,2,2,2],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15,16,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[5,5,5,5,9,0,7,9,0,7,9,0,7,9,0,15,16,0,7,8,8,8,9,0,7,9,0,7,8,8,8,8,8,8,8,8,9,0,7,9,0,7,8,8,8,9,0,15,16,0,7,9,0,7,9,0,7,9,0,7,5,5,5,5],[0,1,2,2,12,0,15,16,0,15,16,0,15,16,0,15,16,0,15,0,0,0,16,0,15,16,0,15,0,0,0,0,0,0,0,0,16,0,15,16,0,15,0,0,0,16,0,15,16,0,15,16,0,15,16,0,15,16,0,10,2,2,3,0],[0,13,0,0,0,0,15,16,0,15,16,0,15,16,0,15,16,0,15,0,0,0,16,0,15,16,0,15,0,0,0,0,0,0,0,0,16,0,15,16,0,15,0,0,0,16,0,15,16,0,15,16,0,15,16,0,15,16,0,0,0,0,14,0],[0,13,0,7,9,0,15,16,0,10,12,0,15,16,0,15,16,0,10,11,11,11,12,0,15,16,0,15,0,0,0,0,0,0,0,0,16,0,15,16,0,10,11,11,11,12,0,15,16,0,15,16,0,10,12,0,15,16,0,7,9,0,14,0],[0,13,0,15,16,0,15,16,0,0,0,0,15,16,0,15,16,0,0,0,0,0,0,0,15,16,0,10,11,11,11,11,11,11,11,11,12,0,15,16,0,0,0,0,0,0,0,15,16,0,15,16,0,0,0,0,15,16,0,15,16,0,14,0],[0,13,0,15,16,0,15,16,0,7,9,0,15,16,0,15,24,8,8,8,8,8,9,0,15,16,0,0,0,0,0,0,0,0,0,0,0,0,15,16,0,7,8,8,8,8,8,23,16,0,15,16,0,7,9,0,15,16,0,15,16,0,14,0],[0,13,0,15,16,0,15,16,0,15,16,0,15,16,0,10,11,11,11,11,11,11,12,0,15,24,8,8,8,8,8,8,8,8,8,8,8,8,23,16,0,10,11,11,11,11,11,11,12,0,15,16,0,15,16,0,15,16,0,15,16,0,14,0],[0,13,0,15,16,0,15,16,0,10,12,0,15,16,0,0,0,0,0,0,0,0,0,0,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,0,0,0,0,0,0,0,0,0,0,15,16,0,10,12,0,15,16,0,15,16,0,14,0],[0,13,0,15,16,0,15,16,0,0,0,0,15,24,8,8,9,0,7,8,8,8,9,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7,8,8,8,9,0,7,8,8,23,16,0,0,0,0,15,16,0,15,16,0,14,0],[0,13,0,15,16,0,10,12,0,7,9,0,10,11,11,11,12,0,10,11,11,11,12,0,7,5,5,5,5,5,5,5,5,5,5,5,5,5,5,9,0,10,11,11,11,12,0,10,11,11,11,12,0,7,9,0,10,12,0,15,16,0,14,0],[0,13,0,15,16,0,0,0,0,15,16,0,0,0,0,0,0,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,0,0,0,0,0,0,15,16,0,0,0,0,15,16,0,14,0],[0,13,0,15,16,0,7,8,8,23,24,8,9,0,7,8,9,0,7,5,5,5,5,5,6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,5,5,5,5,5,9,0,7,8,9,0,7,8,23,24,8,8,9,0,15,16,0,14,0],[2,12,0,10,12,0,10,11,11,11,11,11,12,0,10,11,12,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,10,11,12,0,10,11,11,11,11,11,12,0,10,12,0,10,2],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,9,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,7,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],\"players\":[{\"x\":8,\"y\":7,\"direction\":1},{\"x\":55,\"y\":29,\"direction\":0}],\"food\":[[{\"x\":32,\"y\":9},{\"x\":31,\"y\":9},{\"x\":30,\"y\":9},{\"x\":29,\"y\":9},{\"x\":28,\"y\":9},{\"x\":23,\"y\":8},{\"x\":23,\"y\":9},{\"x\":24,\"y\":9},{\"x\":25,\"y\":9},{\"x\":26,\"y\":9},{\"x\":27,\"y\":9},{\"x\":33,\"y\":9},{\"x\":34,\"y\":9},{\"x\":35,\"y\":9},{\"x\":36,\"y\":9},{\"x\":37,\"y\":9},{\"x\":38,\"y\":9},{\"x\":39,\"y\":9},{\"x\":40,\"y\":7,\"isPowerup\":true},{\"x\":40,\"y\":8},{\"x\":40,\"y\":9},{\"x\":41,\"y\":7},{\"x\":42,\"y\":7},{\"x\":43,\"y\":7},{\"x\":44,\"y\":7},{\"x\":45,\"y\":7},{\"x\":46,\"y\":3},{\"x\":46,\"y\":4},{\"x\":46,\"y\":5},{\"x\":46,\"y\":6},{\"x\":17,\"y\":3},{\"x\":17,\"y\":4},{\"x\":17,\"y\":5},{\"x\":17,\"y\":6},{\"x\":17,\"y\":7},{\"x\":23,\"y\":10},{\"x\":22,\"y\":7},{\"x\":21,\"y\":7},{\"x\":20,\"y\":7},{\"x\":19,\"y\":7},{\"x\":18,\"y\":7},{\"x\":23,\"y\":11},{\"x\":23,\"y\":12},{\"x\":23,\"y\":13},{\"x\":23,\"y\":14},{\"x\":23,\"y\":15},{\"x\":23,\"y\":16},{\"x\":23,\"y\":17},{\"x\":23,\"y\":18},{\"x\":23,\"y\":19},{\"x\":23,\"y\":20},{\"x\":23,\"y\":21},{\"x\":23,\"y\":22},{\"x\":23,\"y\":23},{\"x\":23,\"y\":24},{\"x\":23,\"y\":25},{\"x\":23,\"y\":26},{\"x\":23,\"y\":27},{\"x\":23,\"y\":28},{\"x\":40,\"y\":10},{\"x\":40,\"y\":11},{\"x\":40,\"y\":12},{\"x\":40,\"y\":13},{\"x\":40,\"y\":14},{\"x\":40,\"y\":15},{\"x\":40,\"y\":16},{\"x\":40,\"y\":17},{\"x\":40,\"y\":18},{\"x\":40,\"y\":19},{\"x\":40,\"y\":20},{\"x\":40,\"y\":21},{\"x\":40,\"y\":22},{\"x\":40,\"y\":23},{\"x\":40,\"y\":24},{\"x\":40,\"y\":25},{\"x\":40,\"y\":26},{\"x\":40,\"y\":27},{\"x\":40,\"y\":28},{\"x\":24,\"y\":27},{\"x\":25,\"y\":27},{\"x\":26,\"y\":27},{\"x\":27,\"y\":27},{\"x\":28,\"y\":27},{\"x\":29,\"y\":27},{\"x\":30,\"y\":27},{\"x\":31,\"y\":27},{\"x\":38,\"y\":27},{\"x\":37,\"y\":27},{\"x\":36,\"y\":27},{\"x\":35,\"y\":27},{\"x\":34,\"y\":27},{\"x\":33,\"y\":27},{\"x\":32,\"y\":27},{\"x\":39,\"y\":27},{\"x\":46,\"y\":7},{\"x\":40,\"y\":29,\"isPowerup\":true},{\"x\":41,\"y\":29},{\"x\":42,\"y\":29},{\"x\":43,\"y\":29},{\"x\":44,\"y\":29},{\"x\":45,\"y\":29},{\"x\":46,\"y\":29},{\"x\":46,\"y\":33},{\"x\":46,\"y\":32},{\"x\":46,\"y\":31},{\"x\":46,\"y\":30},{\"x\":23,\"y\":29,\"isPowerup\":true},{\"x\":22,\"y\":29},{\"x\":21,\"y\":29},{\"x\":20,\"y\":29},{\"x\":19,\"y\":29},{\"x\":17,\"y\":29},{\"x\":17,\"y\":33},{\"x\":17,\"y\":32},{\"x\":17,\"y\":31},{\"x\":18,\"y\":29},{\"x\":17,\"y\":30},{\"x\":23,\"y\":7,\"isPowerup\":true}],[{\"x\":26,\"y\":16},{\"x\":26,\"y\":15},{\"x\":26,\"y\":14},{\"x\":26,\"y\":13},{\"x\":26,\"y\":12},{\"x\":27,\"y\":12},{\"x\":28,\"y\":12},{\"x\":29,\"y\":12},{\"x\":30,\"y\":12},{\"x\":31,\"y\":12},{\"x\":32,\"y\":12},{\"x\":33,\"y\":12},{\"x\":34,\"y\":12},{\"x\":35,\"y\":12},{\"x\":36,\"y\":12},{\"x\":37,\"y\":12},{\"x\":37,\"y\":13},{\"x\":37,\"y\":14},{\"x\":37,\"y\":15},{\"x\":37,\"y\":21},{\"x\":37,\"y\":22},{\"x\":37,\"y\":23},{\"x\":37,\"y\":24},{\"x\":36,\"y\":24},{\"x\":35,\"y\":24},{\"x\":34,\"y\":24},{\"x\":33,\"y\":24},{\"x\":32,\"y\":24},{\"x\":31,\"y\":24},{\"x\":30,\"y\":24},{\"x\":29,\"y\":24},{\"x\":28,\"y\":24},{\"x\":27,\"y\":24},{\"x\":26,\"y\":24},{\"x\":26,\"y\":23},{\"x\":26,\"y\":22},{\"x\":26,\"y\":21},{\"x\":37,\"y\":16},{\"x\":37,\"y\":20},{\"x\":21,\"y\":13},{\"x\":20,\"y\":13},{\"x\":19,\"y\":13},{\"x\":18,\"y\":13},{\"x\":17,\"y\":13},{\"x\":17,\"y\":14},{\"x\":17,\"y\":15},{\"x\":17,\"y\":16},{\"x\":17,\"y\":17},{\"x\":17,\"y\":18},{\"x\":17,\"y\":19},{\"x\":17,\"y\":20},{\"x\":17,\"y\":21},{\"x\":17,\"y\":22},{\"x\":17,\"y\":23},{\"x\":18,\"y\":23},{\"x\":19,\"y\":23},{\"x\":20,\"y\":23},{\"x\":21,\"y\":23},{\"x\":42,\"y\":13},{\"x\":43,\"y\":13},{\"x\":44,\"y\":13},{\"x\":45,\"y\":13},{\"x\":46,\"y\":13},{\"x\":46,\"y\":14},{\"x\":46,\"y\":15},{\"x\":46,\"y\":16},{\"x\":46,\"y\":17},{\"x\":46,\"y\":18},{\"x\":46,\"y\":19},{\"x\":46,\"y\":20},{\"x\":46,\"y\":21},{\"x\":46,\"y\":22},{\"x\":46,\"y\":23},{\"x\":45,\"y\":23},{\"x\":44,\"y\":23},{\"x\":42,\"y\":23},{\"x\":14,\"y\":10,\"isPowerup\":true},{\"x\":49,\"y\":10,\"isPowerup\":true},{\"x\":49,\"y\":26,\"isPowerup\":true},{\"x\":14,\"y\":26,\"isPowerup\":true},{\"x\":43,\"y\":23}],[{\"x\":22,\"y\":10},{\"x\":21,\"y\":10},{\"x\":20,\"y\":10},{\"x\":19,\"y\":10},{\"x\":18,\"y\":10},{\"x\":17,\"y\":10},{\"x\":16,\"y\":10},{\"x\":15,\"y\":10},{\"x\":14,\"y\":26},{\"x\":14,\"y\":25},{\"x\":14,\"y\":24},{\"x\":14,\"y\":23},{\"x\":14,\"y\":22},{\"x\":14,\"y\":21},{\"x\":14,\"y\":20},{\"x\":14,\"y\":19},{\"x\":14,\"y\":18},{\"x\":14,\"y\":17},{\"x\":14,\"y\":16},{\"x\":14,\"y\":15},{\"x\":14,\"y\":14},{\"x\":14,\"y\":11},{\"x\":14,\"y\":12},{\"x\":14,\"y\":13},{\"x\":15,\"y\":26},{\"x\":16,\"y\":26},{\"x\":17,\"y\":26},{\"x\":18,\"y\":26},{\"x\":19,\"y\":26},{\"x\":20,\"y\":26},{\"x\":21,\"y\":26},{\"x\":14,\"y\":10},{\"x\":13,\"y\":18},{\"x\":12,\"y\":18},{\"x\":11,\"y\":18},{\"x\":10,\"y\":18},{\"x\":9,\"y\":18},{\"x\":8,\"y\":18},{\"x\":7,\"y\":18},{\"x\":6,\"y\":18},{\"x\":5,\"y\":18},{\"x\":4,\"y\":18},{\"x\":3,\"y\":18},{\"x\":2,\"y\":18},{\"x\":1,\"y\":18},{\"x\":42,\"y\":10},{\"x\":43,\"y\":10},{\"x\":44,\"y\":10},{\"x\":49,\"y\":10},{\"x\":48,\"y\":10},{\"x\":47,\"y\":10},{\"x\":46,\"y\":10},{\"x\":45,\"y\":10},{\"x\":49,\"y\":26},{\"x\":49,\"y\":25},{\"x\":49,\"y\":24},{\"x\":49,\"y\":23},{\"x\":49,\"y\":22},{\"x\":49,\"y\":21},{\"x\":49,\"y\":20},{\"x\":49,\"y\":19},{\"x\":49,\"y\":18},{\"x\":49,\"y\":17},{\"x\":49,\"y\":16},{\"x\":49,\"y\":15},{\"x\":49,\"y\":14},{\"x\":49,\"y\":13},{\"x\":49,\"y\":12},{\"x\":49,\"y\":11},{\"x\":42,\"y\":26},{\"x\":43,\"y\":26},{\"x\":44,\"y\":26},{\"x\":45,\"y\":26},{\"x\":46,\"y\":26},{\"x\":47,\"y\":26},{\"x\":48,\"y\":26},{\"x\":50,\"y\":18},{\"x\":51,\"y\":18},{\"x\":52,\"y\":18},{\"x\":53,\"y\":18},{\"x\":54,\"y\":18},{\"x\":55,\"y\":18},{\"x\":56,\"y\":18},{\"x\":57,\"y\":18},{\"x\":62,\"y\":18},{\"x\":63,\"y\":18},{\"x\":61,\"y\":18},{\"x\":60,\"y\":18},{\"x\":59,\"y\":18},{\"x\":58,\"y\":18},{\"x\":0,\"y\":18},{\"x\":52,\"y\":7,\"isPowerup\":true},{\"x\":52,\"y\":29,\"isPowerup\":true},{\"x\":11,\"y\":7,\"isPowerup\":true},{\"x\":11,\"y\":29,\"isPowerup\":true}],[{\"x\":48,\"y\":4},{\"x\":49,\"y\":4},{\"x\":50,\"y\":4},{\"x\":51,\"y\":4},{\"x\":52,\"y\":4},{\"x\":53,\"y\":4},{\"x\":54,\"y\":4},{\"x\":55,\"y\":4},{\"x\":56,\"y\":4},{\"x\":57,\"y\":4},{\"x\":58,\"y\":4},{\"x\":59,\"y\":4},{\"x\":62,\"y\":4},{\"x\":63,\"y\":4},{\"x\":61,\"y\":4},{\"x\":60,\"y\":4},{\"x\":61,\"y\":6},{\"x\":61,\"y\":7},{\"x\":61,\"y\":8},{\"x\":61,\"y\":9},{\"x\":61,\"y\":10},{\"x\":61,\"y\":11},{\"x\":61,\"y\":12},{\"x\":61,\"y\":13},{\"x\":61,\"y\":14},{\"x\":61,\"y\":15},{\"x\":60,\"y\":15},{\"x\":59,\"y\":15},{\"x\":61,\"y\":5},{\"x\":58,\"y\":15},{\"x\":58,\"y\":14},{\"x\":58,\"y\":13},{\"x\":58,\"y\":12},{\"x\":58,\"y\":11},{\"x\":58,\"y\":10},{\"x\":58,\"y\":9},{\"x\":58,\"y\":8},{\"x\":58,\"y\":7},{\"x\":58,\"y\":6},{\"x\":46,\"y\":4},{\"x\":46,\"y\":3},{\"x\":46,\"y\":2},{\"x\":46,\"y\":1},{\"x\":47,\"y\":4},{\"x\":46,\"y\":6},{\"x\":46,\"y\":7},{\"x\":45,\"y\":7},{\"x\":44,\"y\":7},{\"x\":43,\"y\":7},{\"x\":42,\"y\":7},{\"x\":41,\"y\":7},{\"x\":46,\"y\":5},{\"x\":40,\"y\":7},{\"x\":40,\"y\":8},{\"x\":40,\"y\":9},{\"x\":39,\"y\":9},{\"x\":38,\"y\":9},{\"x\":37,\"y\":9},{\"x\":36,\"y\":9},{\"x\":35,\"y\":9},{\"x\":34,\"y\":9},{\"x\":33,\"y\":9},{\"x\":32,\"y\":9},{\"x\":31,\"y\":9},{\"x\":30,\"y\":9},{\"x\":29,\"y\":9},{\"x\":23,\"y\":9},{\"x\":24,\"y\":9},{\"x\":25,\"y\":9},{\"x\":26,\"y\":9},{\"x\":27,\"y\":9},{\"x\":28,\"y\":9},{\"x\":23,\"y\":8},{\"x\":23,\"y\":7},{\"x\":17,\"y\":7},{\"x\":18,\"y\":7},{\"x\":19,\"y\":7},{\"x\":22,\"y\":7},{\"x\":21,\"y\":7},{\"x\":20,\"y\":7},{\"x\":17,\"y\":6},{\"x\":17,\"y\":5},{\"x\":17,\"y\":4},{\"x\":17,\"y\":3},{\"x\":17,\"y\":2},{\"x\":17,\"y\":1},{\"x\":17,\"y\":0},{\"x\":46,\"y\":0},{\"x\":0,\"y\":4},{\"x\":1,\"y\":4},{\"x\":2,\"y\":4},{\"x\":3,\"y\":4},{\"x\":4,\"y\":4},{\"x\":5,\"y\":4},{\"x\":6,\"y\":4},{\"x\":7,\"y\":4},{\"x\":8,\"y\":4},{\"x\":9,\"y\":4},{\"x\":10,\"y\":4},{\"x\":11,\"y\":4},{\"x\":13,\"y\":4},{\"x\":14,\"y\":4},{\"x\":15,\"y\":4},{\"x\":16,\"y\":4},{\"x\":58,\"y\":21},{\"x\":59,\"y\":21},{\"x\":60,\"y\":21},{\"x\":61,\"y\":21},{\"x\":58,\"y\":16},{\"x\":58,\"y\":17},{\"x\":58,\"y\":18},{\"x\":58,\"y\":19},{\"x\":58,\"y\":20},{\"x\":61,\"y\":22},{\"x\":61,\"y\":23},{\"x\":61,\"y\":24},{\"x\":61,\"y\":25},{\"x\":61,\"y\":26},{\"x\":61,\"y\":27},{\"x\":61,\"y\":28},{\"x\":61,\"y\":29},{\"x\":61,\"y\":30},{\"x\":61,\"y\":31},{\"x\":61,\"y\":32},{\"x\":58,\"y\":32},{\"x\":58,\"y\":31},{\"x\":58,\"y\":30},{\"x\":58,\"y\":29},{\"x\":58,\"y\":28},{\"x\":58,\"y\":27},{\"x\":58,\"y\":26},{\"x\":58,\"y\":25},{\"x\":58,\"y\":24},{\"x\":58,\"y\":23},{\"x\":59,\"y\":32},{\"x\":60,\"y\":32},{\"x\":62,\"y\":32},{\"x\":63,\"y\":32},{\"x\":47,\"y\":32},{\"x\":48,\"y\":32},{\"x\":49,\"y\":32},{\"x\":50,\"y\":32},{\"x\":51,\"y\":32},{\"x\":52,\"y\":32},{\"x\":53,\"y\":32},{\"x\":54,\"y\":32},{\"x\":55,\"y\":32},{\"x\":56,\"y\":32},{\"x\":57,\"y\":32},{\"x\":46,\"y\":36},{\"x\":46,\"y\":35},{\"x\":46,\"y\":34},{\"x\":46,\"y\":33},{\"x\":46,\"y\":32},{\"x\":17,\"y\":32},{\"x\":17,\"y\":33},{\"x\":17,\"y\":34},{\"x\":17,\"y\":35},{\"x\":17,\"y\":36},{\"x\":16,\"y\":32},{\"x\":15,\"y\":32},{\"x\":14,\"y\":32},{\"x\":13,\"y\":32},{\"x\":12,\"y\":32},{\"x\":11,\"y\":32},{\"x\":10,\"y\":32},{\"x\":9,\"y\":32},{\"x\":8,\"y\":32},{\"x\":7,\"y\":32},{\"x\":6,\"y\":32},{\"x\":5,\"y\":32},{\"x\":4,\"y\":32},{\"x\":3,\"y\":32},{\"x\":2,\"y\":32},{\"x\":1,\"y\":32},{\"x\":0,\"y\":32},{\"x\":2,\"y\":31},{\"x\":2,\"y\":30},{\"x\":2,\"y\":29},{\"x\":2,\"y\":28},{\"x\":2,\"y\":27},{\"x\":2,\"y\":26},{\"x\":2,\"y\":25},{\"x\":2,\"y\":24},{\"x\":2,\"y\":23},{\"x\":2,\"y\":22},{\"x\":2,\"y\":21},{\"x\":3,\"y\":21},{\"x\":4,\"y\":21},{\"x\":5,\"y\":21},{\"x\":5,\"y\":22},{\"x\":5,\"y\":23},{\"x\":5,\"y\":24},{\"x\":5,\"y\":25},{\"x\":5,\"y\":26},{\"x\":5,\"y\":27},{\"x\":5,\"y\":28},{\"x\":5,\"y\":29},{\"x\":5,\"y\":30},{\"x\":5,\"y\":31},{\"x\":58,\"y\":22},{\"x\":5,\"y\":20},{\"x\":5,\"y\":19},{\"x\":5,\"y\":18},{\"x\":5,\"y\":17},{\"x\":5,\"y\":16},{\"x\":5,\"y\":15},{\"x\":5,\"y\":14},{\"x\":5,\"y\":13},{\"x\":5,\"y\":12},{\"x\":5,\"y\":11},{\"x\":5,\"y\":10},{\"x\":5,\"y\":9},{\"x\":5,\"y\":8},{\"x\":5,\"y\":7},{\"x\":5,\"y\":6},{\"x\":5,\"y\":5},{\"x\":4,\"y\":15},{\"x\":3,\"y\":15},{\"x\":2,\"y\":15},{\"x\":2,\"y\":14},{\"x\":2,\"y\":13},{\"x\":2,\"y\":12},{\"x\":2,\"y\":11},{\"x\":2,\"y\":10},{\"x\":2,\"y\":9},{\"x\":2,\"y\":8},{\"x\":2,\"y\":7},{\"x\":2,\"y\":6},{\"x\":2,\"y\":5},{\"x\":12,\"y\":4},{\"x\":17,\"y\":31},{\"x\":17,\"y\":30},{\"x\":17,\"y\":29},{\"x\":18,\"y\":29},{\"x\":19,\"y\":29},{\"x\":20,\"y\":29},{\"x\":21,\"y\":29},{\"x\":22,\"y\":29},{\"x\":23,\"y\":29},{\"x\":23,\"y\":28},{\"x\":23,\"y\":27},{\"x\":24,\"y\":27},{\"x\":25,\"y\":27},{\"x\":26,\"y\":27},{\"x\":27,\"y\":27},{\"x\":28,\"y\":27},{\"x\":29,\"y\":27},{\"x\":30,\"y\":27},{\"x\":31,\"y\":27},{\"x\":32,\"y\":27},{\"x\":33,\"y\":27},{\"x\":34,\"y\":27},{\"x\":35,\"y\":27},{\"x\":36,\"y\":27},{\"x\":39,\"y\":27},{\"x\":40,\"y\":27},{\"x\":38,\"y\":27},{\"x\":37,\"y\":27},{\"x\":40,\"y\":28},{\"x\":40,\"y\":29},{\"x\":41,\"y\":29},{\"x\":42,\"y\":29},{\"x\":43,\"y\":29},{\"x\":44,\"y\":29},{\"x\":45,\"y\":29},{\"x\":46,\"y\":29},{\"x\":46,\"y\":30},{\"x\":46,\"y\":31},{\"x\":29,\"y\":18,\"isPowerup\":true},{\"x\":34,\"y\":18,\"isPowerup\":true},{\"x\":58,\"y\":5}]],\"ghosts\":[{\"name\":\"blinky\",\"x\":26,\"y\":12,\"direction\":3},{\"name\":\"pinky\",\"x\":37,\"y\":24,\"direction\":2},{\"name\":\"inky\",\"x\":37,\"y\":12,\"direction\":2},{\"name\":\"clyde\",\"x\":26,\"y\":24,\"direction\":1}]}");


const $0b89d474933103bc$var$emptyLevel = {
    name: 'emptyLevel',
    maze: [],
    players: [],
    ghosts: [],
    food: [
        []
    ]
};
class $0b89d474933103bc$export$2e2bcd8739ae039 {
    get gameState() {
        return this._gameState;
    }
    set gameState(value) {
        this._gameState = value;
    }
    get level() {
        return this._level ?? $0b89d474933103bc$var$emptyLevel;
    }
    get map() {
        return this._level?.maze ?? [];
    }
    get players() {
        return this._players;
    }
    get ghosts() {
        return this._ghosts;
    }
    get displayScore() {
        return 0;
    // const score = this.score.toString();
    // return `${'0000'.substr(0, 4 - score.length)}${score}`;
    }
    get foodLayer() {
        return this._foodLayer;
    }
    set foodLayer(value) {
        this._foodLayer = value;
    }
    get food() {
        return this._food;
    }
    resetFood() {
        this._food = [
            ...this.level.food[this.foodLayer % this.level.food.length]
        ];
    }
    set food(value) {
        this._food = value;
    }
    eatFood(position) {
        this._food = this._food.filter((f)=>!(0, $59ac15d34719d398$export$2e2bcd8739ae039).isSame(position, new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(f.x, f.y)));
        if (this._food.length === 0) {
            this.foodLayer++;
            this.resetFood();
        }
    }
    constructor(){
        this.gameTime = 0;
        this._gameState = (0, $3b35f402ec1d6958$export$eb5ccdbd077479c).Paused;
        this._currentLevel = 1;
        this._players = [];
        this._ghosts = [];
        this._foodLayer = 0;
        this._food = [];
        this.isGameOver = ()=>!this.players.some((p)=>!p.isDead);
        window.__state = this;
    }
    reset() {
        this.gameTime = 0;
        this.gameState = (0, $3b35f402ec1d6958$export$eb5ccdbd077479c).Ready;
        this.resetLevel();
        this.resetStage();
    }
    loadLevel(levelNumber) {
        // import level from `./levels/level-${levelNumber}.json`;
        // const level = import
        // const level = require(`./levels/level-${levelNumber}.json`) as Level;
        this._level = (0, (/*@__PURE__*/$parcel$interopDefault($8c635492ff8c26eb$exports)));
    }
    resetLevel() {
        this.loadLevel(this._currentLevel);
        this._foodLayer = 0;
        this.resetFood();
    // this._food = this.level.food[this.foodRound];
    }
    resetStage() {
        this.resetPlayers();
        this.resetGhosts();
    }
    respawnPlayer(index) {
        const player = this.level.players[index];
        const playerPos = new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(player.x, player.y);
        this.players[index].position = playerPos;
        this.players[index].target = playerPos;
        this.players[index].direction = player.direction;
        this.players[index].isRespawning = false;
    }
    resetPlayers() {
        this._players = this.level.players.map((p, i)=>{
            const pos = new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(p.x, p.y);
            const player = new (0, $16adc9a2295ce702$export$2e2bcd8739ae039)(pos, pos, p.direction, `player-${i}`);
            player.lives = 3;
            player.score = 0;
            return player;
        });
    }
    resetGhosts() {
        this._ghosts = this.level.ghosts.map((g)=>{
            const pos = new (0, $59ac15d34719d398$export$2e2bcd8739ae039)(g.x, g.y);
            const ghost = new (0, $16adc9a2295ce702$export$2e2bcd8739ae039)(pos, pos, g.direction, g.name);
            ghost.lives = 1;
            return ghost;
        });
    }
    updateMap(pos, tile) {
        this.map[pos.y][pos.x] = tile;
    }
}


class $e46db5192eb49d53$export$2e2bcd8739ae039 {
    constructor(selector, width, height){
        this.width = width;
        this.height = height;
        this.framerate = 10;
        this.state = new (0, $0b89d474933103bc$export$2e2bcd8739ae039)();
        this._lastUpdate = Date.now();
        this._xDown = null;
        this._yDown = null;
        this.container = document.querySelector(selector);
        this.canvas = document.createElement('canvas');
        this.canvas.width = this.width;
        this.canvas.height = this.height;
        this.ctx = this.canvas.getContext('2d');
        this.container.appendChild(this.canvas);
        this.screenManager = new (0, $d97f67d971fb3f87$export$cabb9ed6ac90bb6)(this.state, this.width, this.height);
        this.reset();
        this.bindControls();
        this.mainloop();
    }
    reset() {
        this.state.reset();
        this.state.gameState = (0, $3b35f402ec1d6958$export$eb5ccdbd077479c).Playing;
    }
    bindControls() {
        document.addEventListener('keydown', (e)=>this.onKeyDown(e));
        document.addEventListener('touchstart', (e)=>this.onTouchStart(e));
        document.addEventListener('touchmove', (e)=>this.onTouchMove(e));
        document.addEventListener('touchend', (e)=>this.onTouchEnd(e));
        (0, $1db270861bd59532$export$2e2bcd8739ae039).on('connected', (evt)=>{
            console.log('connected', evt.gamepad);
        });
        (0, $1db270861bd59532$export$2e2bcd8739ae039).on('axis_changed', (evt)=>{
            const player = this.state.players[evt.gamepad.index];
            let key;
            switch(evt.axis){
                case 0:
                    if (evt.value === -1) key = (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Left;
                    else if (evt.value === 1) key = (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Right;
                    break;
                case 1:
                    if (evt.value === -1) key = (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Up;
                    else if (evt.value === 1) key = (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Down;
                    break;
            }
            if (key !== undefined) this.screenManager.getCurrentScreen().onPlayerInput(player, key, this.state);
        });
    }
    onTouchStart(e) {
        e.preventDefault();
        const { clientX: clientX, clientY: clientY } = e.touches[0];
        this._xDown = clientX;
        this._yDown = clientY;
    }
    onTouchEnd(e) {}
    onTouchMove(e) {
        const { state: state } = this;
        const [player1] = state.players;
        const currentScreen = this.screenManager.getCurrentScreen();
        const { _xDown: xDown, _yDown: yDown } = this;
        if (!xDown || !yDown) return;
        const { clientX: clientX, clientY: clientY } = e.touches[0];
        const xDiff = xDown - clientX;
        const yDiff = yDown - clientY;
        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            if (xDiff > 0) currentScreen.onPlayerInput(player1, (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Left, state);
            else currentScreen.onPlayerInput(player1, (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Right, state);
        } else if (yDiff > 0) currentScreen.onPlayerInput(player1, (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Up, state);
        else currentScreen.onPlayerInput(player1, (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Down, state);
        this._xDown = null;
        this._yDown = null;
    }
    onKeyDown(e) {
        const { state: state } = this;
        if (!state) return;
        const isPlaying = this.state.gameState === (0, $3b35f402ec1d6958$export$eb5ccdbd077479c).Playing;
        if (e.keyCode === (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).P) {
            if (isPlaying) this.state.gameState = (0, $3b35f402ec1d6958$export$eb5ccdbd077479c).Paused;
            else this.state.gameState = (0, $3b35f402ec1d6958$export$eb5ccdbd077479c).Playing;
        }
        if (this.state.gameState === (0, $3b35f402ec1d6958$export$eb5ccdbd077479c).Paused) return;
        const [player1, player2] = state.players;
        const currentScreen = this.screenManager.getCurrentScreen();
        switch(e.keyCode){
            case (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Left:
                currentScreen.onPlayerInput(player1, (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Left, this.state);
                break;
            case (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Right:
                currentScreen.onPlayerInput(player1, (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Right, this.state);
                break;
            case (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Down:
                currentScreen.onPlayerInput(player1, (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Down, this.state);
                break;
            case (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Up:
                currentScreen.onPlayerInput(player1, (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Up, this.state);
                break;
            case (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).A:
                currentScreen.onPlayerInput(player2, (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Left, this.state);
                break;
            case (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).D:
                currentScreen.onPlayerInput(player2, (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Right, this.state);
                break;
            case (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).S:
                currentScreen.onPlayerInput(player2, (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Down, this.state);
                break;
            case (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).W:
                currentScreen.onPlayerInput(player2, (0, $3b35f402ec1d6958$export$cd0f44441c3b7719).Up, this.state);
                break;
        }
    }
    mainloop() {
        const deltaTime = Date.now() - this._lastUpdate;
        if (this.state.gameState !== (0, $3b35f402ec1d6958$export$eb5ccdbd077479c).Paused) {
            if (deltaTime >= this.framerate) {
                this._lastUpdate = Date.now();
                this.state.gameTime++;
                this.update(this.state.gameTime);
            }
        }
        this.render(this.state.gameTime, this.ctx);
        requestAnimationFrame(()=>this.mainloop());
    }
    update(gameTime) {
        this.screenManager.getCurrentScreen().update(gameTime, this.state);
    }
    render(gameTime, ctx) {
        this.screenManager.getCurrentScreen().render(this.state, gameTime, ctx);
    }
}


window.addEventListener('DOMContentLoaded', ()=>{
    new (0, $e46db5192eb49d53$export$2e2bcd8739ae039)('#gameContainer', 1024, 592);
});


//# sourceMappingURL=pacman-arena.js.map
